import et, { useMemo as ne, useCallback as ye, useReducer as Pn, useContext as Te, useState as X, useRef as xr, useEffect as pe, memo as gr, createContext as Ar } from "react";
import { useNavigate as Xe, useLocation as Ir, useParams as Rr, useSearchParams as Mn, Routes as St, Route as _e } from "react-router-dom";
import { useSelectedConcepts as Bn, useEntityList as Vn, ModalContext as vt, DialogContext as kn, useEntityNew as $n } from "@prometheus/hooks";
import { Tooltip as Nt, Grid as C, Block as st, BlockTitle as Gn, Icon as fe, NewTable as Yn, FilterPanel as zn, InputFilter as Wn, useNotifications as at, ContentBlock as it, Table as Or, Typography as re, Spinner as Ue, Button as Ae, Paper as br, Box as ie, Input as we, Select as We, AnalysisIcon as ar, EditableInput as ir, IconActionButton as be, Divider as _r } from "@prometheus/components";
import { ID_COLUMN as jt, NAME_COLUMN as ot, CREATED_COLUMN as Dt, UPDATED_COLUMN as Ut, AUTHOR_COLUMN as wt, EntityTypeCell as Ce, NameCell as Ft, ActionCell as ft, ICON_COLUMN as Sr, FloatingButton as qn, SpinnerWidgetContainer as Fe, TabsNavigationNew as lt, RemoveButton as Hn, FormElement as Ne, FormActionsContainer as vr, EntityImport as Qn, PageList as Lt, InlineFormElement as Xn, CodeEditor as Nr, useIsLibraryDataSteward as Jn, TabWithCounter as Ct, ErrorPage as Et, SpinnerContainer as jr, NestedInfoWrapper as Dr, SecondaryContentWrapper as Ur, ExportMultipleSource as Kn, PublishEntity as Zn, ConfirmationDialog as es, FeatureAnalysisBaseInfo as ts } from "@prometheus/features";
import { NameConflictResolution as Pt, TypesOfContainer as Z, EntityIconNames as Ee, OtherImportTypes as or, FileExtension as wr, iconAnalyses as ht, EntityTypes as rs } from "@prometheus/enums";
import { api as ee, getSortDirection as Mt, createSortingMethodListConfig as Bt, createFiltersPanelListConfig as tt, populateColumnsConfigWithSort as ns, separateSearchFilters as ss, getReducerWithProduce as as, getUUID as Ge, createCrudMethodsListConfig as Fr, parseActions as Vt, createBreadcrumbsEntityConfig as Lr, createCrudEntityConfig as Pr, formatFilterListNoFiql as is, getFormatDateAndTime as os, getPublishOriginBreadcrumb as ls, isEqual as lr, convertExtendedToLegacyConcepts as us } from "@prometheus/utils";
import { Status as ae } from "@prometheus/types";
import { useDispatch as Mr, useSelector as cs } from "react-redux";
import { setBreadcrumbs as Br } from "@prometheus/redux";
import { useTheme as ds } from "@emotion/react";
var Tt = { exports: {} }, Be = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ur;
function ms() {
  if (ur) return Be;
  ur = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function r(n, a, i) {
    var o = null;
    if (i !== void 0 && (o = "" + i), a.key !== void 0 && (o = "" + a.key), "key" in a) {
      i = {};
      for (var c in a)
        c !== "key" && (i[c] = a[c]);
    } else i = a;
    return a = i.ref, {
      $$typeof: e,
      type: n,
      key: o,
      ref: a !== void 0 ? a : null,
      props: i
    };
  }
  return Be.Fragment = t, Be.jsx = r, Be.jsxs = r, Be;
}
var Ve = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cr;
function ps() {
  return cr || (cr = 1, process.env.NODE_ENV !== "production" && function() {
    function e(l) {
      if (l == null) return null;
      if (typeof l == "function")
        return l.$$typeof === w ? null : l.displayName || l.name || null;
      if (typeof l == "string") return l;
      switch (l) {
        case x:
          return "Fragment";
        case f:
          return "Profiler";
        case y:
          return "StrictMode";
        case U:
          return "Suspense";
        case D:
          return "SuspenseList";
        case _:
          return "Activity";
      }
      if (typeof l == "object")
        switch (typeof l.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), l.$$typeof) {
          case S:
            return "Portal";
          case I:
            return (l.displayName || "Context") + ".Provider";
          case N:
            return (l._context.displayName || "Context") + ".Consumer";
          case j:
            var R = l.render;
            return l = l.displayName, l || (l = R.displayName || R.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
          case W:
            return R = l.displayName || null, R !== null ? R : e(l.type) || "Memo";
          case d:
            R = l._payload, l = l._init;
            try {
              return e(l(R));
            } catch {
            }
        }
      return null;
    }
    function t(l) {
      return "" + l;
    }
    function r(l) {
      try {
        t(l);
        var R = !1;
      } catch {
        R = !0;
      }
      if (R) {
        R = console;
        var P = R.error, q = typeof Symbol == "function" && Symbol.toStringTag && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return P.call(
          R,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          q
        ), t(l);
      }
    }
    function n(l) {
      if (l === x) return "<>";
      if (typeof l == "object" && l !== null && l.$$typeof === d)
        return "<...>";
      try {
        var R = e(l);
        return R ? "<" + R + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function a() {
      var l = M.A;
      return l === null ? null : l.getOwner();
    }
    function i() {
      return Error("react-stack-top-frame");
    }
    function o(l) {
      if (se.call(l, "key")) {
        var R = Object.getOwnPropertyDescriptor(l, "key").get;
        if (R && R.isReactWarning) return !1;
      }
      return l.key !== void 0;
    }
    function c(l, R) {
      function P() {
        F || (F = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          R
        ));
      }
      P.isReactWarning = !0, Object.defineProperty(l, "key", {
        get: P,
        configurable: !0
      });
    }
    function m() {
      var l = e(this.type);
      return V[l] || (V[l] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), l = this.props.ref, l !== void 0 ? l : null;
    }
    function p(l, R, P, q, H, v, Q, ue) {
      return P = v.ref, l = {
        $$typeof: O,
        type: l,
        key: R,
        props: v,
        _owner: H
      }, (P !== void 0 ? P : null) !== null ? Object.defineProperty(l, "ref", {
        enumerable: !1,
        get: m
      }) : Object.defineProperty(l, "ref", { enumerable: !1, value: null }), l._store = {}, Object.defineProperty(l._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(l, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(l, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Q
      }), Object.defineProperty(l, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ue
      }), Object.freeze && (Object.freeze(l.props), Object.freeze(l)), l;
    }
    function A(l, R, P, q, H, v, Q, ue) {
      var G = R.children;
      if (G !== void 0)
        if (q)
          if (J(G)) {
            for (q = 0; q < G.length; q++)
              E(G[q]);
            Object.freeze && Object.freeze(G);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else E(G);
      if (se.call(R, "key")) {
        G = e(l);
        var ce = Object.keys(R).filter(function(Re) {
          return Re !== "key";
        });
        q = 0 < ce.length ? "{key: someKey, " + ce.join(": ..., ") + ": ...}" : "{key: someKey}", $[G + q] || (ce = 0 < ce.length ? "{" + ce.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          q,
          G,
          ce,
          G
        ), $[G + q] = !0);
      }
      if (G = null, P !== void 0 && (r(P), G = "" + P), o(R) && (r(R.key), G = "" + R.key), "key" in R) {
        P = {};
        for (var Ie in R)
          Ie !== "key" && (P[Ie] = R[Ie]);
      } else P = R;
      return G && c(
        P,
        typeof l == "function" ? l.displayName || l.name || "Unknown" : l
      ), p(
        l,
        G,
        v,
        H,
        a(),
        P,
        Q,
        ue
      );
    }
    function E(l) {
      typeof l == "object" && l !== null && l.$$typeof === O && l._store && (l._store.validated = 1);
    }
    var g = et, O = Symbol.for("react.transitional.element"), S = Symbol.for("react.portal"), x = Symbol.for("react.fragment"), y = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), N = Symbol.for("react.consumer"), I = Symbol.for("react.context"), j = Symbol.for("react.forward_ref"), U = Symbol.for("react.suspense"), D = Symbol.for("react.suspense_list"), W = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), _ = Symbol.for("react.activity"), w = Symbol.for("react.client.reference"), M = g.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, se = Object.prototype.hasOwnProperty, J = Array.isArray, h = console.createTask ? console.createTask : function() {
      return null;
    };
    g = {
      react_stack_bottom_frame: function(l) {
        return l();
      }
    };
    var F, V = {}, Y = g.react_stack_bottom_frame.bind(
      g,
      i
    )(), te = h(n(i)), $ = {};
    Ve.Fragment = x, Ve.jsx = function(l, R, P, q, H) {
      var v = 1e4 > M.recentlyCreatedOwnerStacks++;
      return A(
        l,
        R,
        P,
        !1,
        q,
        H,
        v ? Error("react-stack-top-frame") : Y,
        v ? h(n(l)) : te
      );
    }, Ve.jsxs = function(l, R, P, q, H) {
      var v = 1e4 > M.recentlyCreatedOwnerStacks++;
      return A(
        l,
        R,
        P,
        !0,
        q,
        H,
        v ? Error("react-stack-top-frame") : Y,
        v ? h(n(l)) : te
      );
    };
  }()), Ve;
}
process.env.NODE_ENV === "production" ? Tt.exports = ms() : Tt.exports = ps();
var s = Tt.exports, k = /* @__PURE__ */ ((e) => (e.PRESET = "PRESET", e.CRITERIA_SET = "CRITERIA_SET", e.CUSTOM_SQL = "CUSTOM_SQL", e))(k || {}), xe = /* @__PURE__ */ ((e) => (e.CUSTOM_FE = "CUSTOM_FE", e.CRITERIA_SET = "CRITERIA_SET", e))(xe || {}), L = /* @__PURE__ */ ((e) => (e.DISTRIBUTION = "DISTRIBUTION", e.PREVALENCE = "PREVALENCE", e.CUSTOM = "CUSTOM", e))(L || {}), oe = /* @__PURE__ */ ((e) => (e.EVENTS_COUNT = "EVENTS_COUNT", e))(oe || {}), K = /* @__PURE__ */ ((e) => (e.ARTIFACTS_LIBRARY = "ARTIFACTS_LIBRARY", e.CUSTOM_FEATURE_STORE = "CUSTOM_FEATURE_STORE", e))(K || {});
const Vr = [
  { value: L.DISTRIBUTION, name: "Distribution" },
  { value: L.PREVALENCE, name: "Prevalence" },
  { value: L.CUSTOM, name: "Custom" }
];
k.CRITERIA_SET, k.CUSTOM_SQL;
const kr = [
  { value: "DEMOGRAPHICS", name: "Demographics" },
  { value: "CONDITION", name: "Condition" },
  { value: "CONDITION_ERA", name: "Condition Era" },
  { value: "DRUG", name: "Drug" },
  { value: "DRUG_ERA", name: "Drug Era" },
  { value: "MEASUREMENT", name: "Measurement" },
  { value: "OBSERVATION", name: "Observation" },
  { value: "PROCEDURE", name: "Procedure" },
  { value: "DEVICE", name: "Device" },
  { value: "VISIT", name: "Visit" },
  { value: "LOCATION", name: "Location" }
], ys = [
  {
    value: oe.EVENTS_COUNT,
    name: "Events count"
  }
], fs = [
  { value: "DISTINCT_START_DAYS", name: "Distinct start days" },
  { value: "DURATION", name: "Duration" },
  { value: "DURATION_AVERAGE", name: "Duration (average)" },
  { value: "DURATION_MAX", name: "Duration (max)" },
  { value: "DURATION_MIN", name: "Duration (min)" },
  { value: oe.EVENTS_COUNT, name: "Events count" }
], Cs = {
  CONDITION_ERA: [
    { value: "CONDITION_OCCURRENCE_COUNT", name: "Condition occurrence count" },
    {
      value: "CONDITION_OCCURRENCE_COUNT_AVERAGE",
      name: "Condition occurrence count (average)"
    },
    {
      value: "CONDITION_OCCURRENCE_COUNT_MAX",
      name: "Condition occurrence count (max)"
    },
    {
      value: "CONDITION_OCCURRENCE_COUNT_MIN",
      name: "Condition occurrence count (min)"
    }
  ],
  DRUG_ERA: [
    { value: "DRUG_EXPOSURE_COUNT", name: "Drug exposure count" },
    {
      value: "DRUG_EXPOSURE_COUNT_AVERAGE",
      name: "Drug exposure count (average)"
    },
    { value: "DRUG_EXPOSURE_COUNT_MAX", name: "Drug exposure count (max)" },
    { value: "DRUG_EXPOSURE_COUNT_MIN", name: "Drug exposure count (min)" },
    { value: "GAP_DAYS", name: "Gap days" },
    { value: "GAP_DAYS_AVERAGE", name: "Gap days (average)" },
    { value: "GAP_DAYS_MAX", name: "Gap days (max)" },
    { value: "GAP_DAYS_MIN", name: "Gap days (min)" }
  ],
  DRUG_EXPOSURE: [
    { value: "DAYS_SUPPLY", name: "Days supply" },
    { value: "DAYS_SUPPLY_AVERAGE", name: "Days supply (average)" },
    { value: "DAYS_SUPPLY_MAX", name: "Days supply (max)" },
    { value: "DAYS_SUPPLY_MIN", name: "Days supply (min)" },
    { value: "QUANTITY", name: "Quantity" },
    { value: "QUANTITY_AVERAGE", name: "Quantity (average)" },
    { value: "QUANTITY_MAX", name: "Quantity (max)" },
    { value: "QUANTITY_MIN", name: "Quantity (min)" },
    { value: "REFILLS", name: "Refills" },
    { value: "REFILLS_AVERAGE", name: "Refills (average)" },
    { value: "REFILLS_MAX", name: "Refills (max)" },
    { value: "REFILLS_MIN", name: "Refills (min)" }
  ],
  MEASUREMENT: [
    { value: "RANGE_HIGH", name: "Range high" },
    { value: "RANGE_HIGH_AVERAGE", name: "Range high (average)" },
    { value: "RANGE_HIGH_MAX", name: "Range high (max)" },
    { value: "RANGE_HIGH_MIN", name: "Range high (min)" },
    { value: "RANGE_LOW", name: "Range low" },
    { value: "RANGE_LOW_AVERAGE", name: "Range low (average)" },
    { value: "RANGE_LOW_MAX", name: "Range low (max)" },
    { value: "RANGE_LOW_MIN", name: "Range low (min)" },
    { value: "VALUE_AS_NUMBER", name: "Value as number" },
    { value: "VALUE_AS_NUMBER_AVERAGE", name: "Value as number (average)" },
    { value: "VALUE_AS_NUMBER_MAX", name: "Value as number (max)" },
    { value: "VALUE_AS_NUMBER_MIN", name: "Value as number (min)" }
  ],
  OBSERVATION: [
    { value: "VALUE_AS_NUMBER", name: "Value as number" },
    { value: "VALUE_AS_NUMBER_AVERAGE", name: "Value as number (average)" },
    { value: "VALUE_AS_NUMBER_MAX", name: "Value as number (max)" },
    { value: "VALUE_AS_NUMBER_MIN", name: "Value as number (min)" }
  ],
  PROCEDURE_OCCURRENCE: [
    { value: "QUANTITY", name: "Quantity" },
    { value: "QUANTITY_AVERAGE", name: "Quantity (average)" },
    { value: "QUANTITY_MAX", name: "Quantity (max)" },
    { value: "QUANTITY_MIN", name: "Quantity (min)" }
  ]
}, Es = {
  CONDITIONERA: "CONDITION_ERA",
  DRUGERA: "DRUG_ERA",
  DRUGEXPOSURE: "DRUG_EXPOSURE",
  PROCEDUREOCCURRENCE: "PROCEDURE_OCCURRENCE",
  PAYERPLANPERIOD: "PAYER_PLAN_PERIOD",
  DEMOGRAPHIC: "DEMOGRAPHIC",
  DEMOGRAPHICS: "DEMOGRAPHIC",
  MEASUREMENT: "MEASUREMENT",
  OBSERVATION: "OBSERVATION",
  CONDITIONOCCURRENCE: "CONDITION_OCCURRENCE"
}, hs = (e) => Es[e.replace(/[^a-zA-Z]/g, "").toUpperCase()] || e.replace(/[^a-zA-Z]/g, "").toUpperCase(), $r = (e) => {
  const t = /* @__PURE__ */ new Set(), r = (n) => {
    if (!(!n || typeof n != "object")) {
      if (n.expression && typeof n.expression == "object") {
        r(n.expression);
        return;
      }
      Array.isArray(n.DemographicCriteriaList) && n.DemographicCriteriaList.length && t.add("DEMOGRAPHIC"), Array.isArray(n.CriteriaList) && n.CriteriaList.forEach((a) => {
        const i = a == null ? void 0 : a.Criteria;
        i && typeof i == "object" && Object.keys(i).forEach((o) => {
          t.add(hs(o));
        });
      }), Array.isArray(n.Groups) && n.Groups.forEach(r);
    }
  };
  return (e || []).forEach(r), Array.from(t);
}, Ts = (e) => {
  const t = $r(e);
  if (!t.length)
    return ys;
  const r = /* @__PURE__ */ new Map();
  return t.some((a) => a !== "DEMOGRAPHIC") ? fs.forEach((a) => {
    r.set(a.value, a);
  }) : r.set(oe.EVENTS_COUNT, {
    value: oe.EVENTS_COUNT,
    name: "Events count"
  }), t.forEach((a) => {
    (Cs[a] || []).forEach((o) => {
      r.set(o.value, o);
    });
  }), Array.from(r.values());
}, Gr = (e) => $r([e]).some((t) => t !== "DEMOGRAPHIC"), Yr = (e) => Ts([e]), kt = {
  [L.DISTRIBUTION]: {
    allowedSubtypes: [k.CRITERIA_SET],
    supportsCriteria: !0,
    supportsSql: !1,
    supportsDistributeBy: !0,
    defaultDistributeBy: oe.EVENTS_COUNT
  },
  [L.PREVALENCE]: {
    allowedSubtypes: [k.CRITERIA_SET],
    supportsCriteria: !0,
    supportsSql: !1,
    supportsDistributeBy: !1,
    defaultDistributeBy: ""
  },
  [L.CUSTOM]: {
    allowedSubtypes: [k.CUSTOM_SQL],
    supportsCriteria: !1,
    supportsSql: !0,
    supportsDistributeBy: !1,
    defaultDistributeBy: ""
  }
}, xs = (e) => e === k.CUSTOM_SQL ? xe.CUSTOM_FE : xe.CRITERIA_SET, gs = [
  "@cdm_database_schema",
  "@cohort_table",
  "@cohort_id",
  "@analysis_id",
  "@vocabulary_database_schema",
  "@result_database_schema"
], As = `-- Custom analysis producing same results as Feature Extraction's "One covariate per drug in the drug_era table overlapping with any time prior to index."
SELECT
  CAST(drug_concept_id AS BIGINT) * 1000 + @analysis_id AS covariate_id,
  c.concept_name AS covariate_name,
  drug_concept_id AS concept_id,
  COUNT(*) AS sum_value,
  COUNT(*) * 1.0 / stat.total_cnt * 1.0 AS average_value
FROM (
  SELECT DISTINCT
    drug_concept_id,
    cohort.subject_id,
    cohort.cohort_start_date
  FROM @cohort_table cohort
  INNER JOIN @cdm_database_schema.drug_era ON cohort.subject_id = drug_era.person_id
  WHERE drug_era_start_date <= cohort.cohort_start_date
    AND drug_concept_id != 0
    AND cohort.cohort_definition_id = @cohort_id
) drug_entries
JOIN @cdm_database_schema.concept c ON drug_entries.drug_concept_id = c.concept_id
CROSS JOIN (
  SELECT COUNT(*) total_cnt
  FROM @cohort_table
  WHERE cohort_definition_id = @cohort_id
) stat
GROUP BY drug_concept_id, c.concept_name, stat.total_cnt`, $t = "new", xt = "CriteriaGroup", rt = "WindowedCriteria", Gt = "DemographicCriteria", zr = "DISTINCT_START_DAYS", Wr = "START_DATE", gt = "DISTINCT v.start_date", At = {
  Type: "ALL",
  CriteriaList: [],
  DemographicCriteriaList: [],
  Groups: []
}, Is = {
  IsDistinct: !1,
  Type: 2,
  Count: 1,
  CountColumn: void 0
}, dt = {
  Start: {
    Coeff: -1
  },
  End: {
    Coeff: 1
  },
  UseIndexEnd: !1,
  UseEventEnd: !1
}, Rs = () => ({
  ...Is
}), Os = () => ({
  ...dt,
  Start: { ...dt.Start },
  End: { ...dt.End }
}), bs = /* @__PURE__ */ new Set([
  "ConditionOccurrence",
  "DeviceExposure",
  "DrugExposure",
  "Measurement",
  "Observation",
  "PayerPlanPeriod",
  "ProcedureOccurrence",
  "VisitOccurrence",
  "VisitDetail"
]), _s = /* @__PURE__ */ new Set([
  "ConditionEra",
  "ConditionOccurrence",
  "Death",
  "DeviceExposure",
  "DoseEra",
  "DrugEra",
  "DrugExposure",
  "LocationRegion",
  "Measurement",
  "Observation",
  "ObservationPeriod",
  "PayerPlanPeriod",
  "ProcedureOccurrence",
  "Specimen",
  "VisitOccurrence",
  "VisitDetail"
]), Ss = "LocationRegion", vs = {
  AVERAGE: "AVG",
  MAX: "MAX",
  MIN: "MIN"
}, Ns = {
  CONDITION: "ConditionOccurrence",
  CONDITIONOCCURRENCE: "ConditionOccurrence",
  CONDITIONERA: "ConditionEra",
  DEATH: "Death",
  DEVICE: "DeviceExposure",
  DEVICEEXPOSURE: "DeviceExposure",
  DOSEERA: "DoseEra",
  DRUG: "DrugExposure",
  DRUGEXPOSURE: "DrugExposure",
  DRUGERA: "DrugEra",
  LOCATION: "LocationRegion",
  LOCATIONREGION: "LocationRegion",
  MEASUREMENT: "Measurement",
  OBSERVATION: "Observation",
  OBSERVATIONPERIOD: "ObservationPeriod",
  PAYERPLANPERIOD: "PayerPlanPeriod",
  PROCEDURE: "ProcedureOccurrence",
  PROCEDUREOCCURRENCE: "ProcedureOccurrence",
  SPECIMEN: "Specimen",
  VISIT: "VisitOccurrence",
  VISITOCCURRENCE: "VisitOccurrence",
  VISITDETAIL: "VisitDetail"
}, z = (e) => typeof e == "string" ? e : "", ve = (e) => Array.isArray(e) ? e[0] : e, Oe = (e) => z(ve(e)), js = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, dr = (e) => typeof e == "string" && js.test(e), Ds = (e) => Ns[e.replace(/[^a-zA-Z]/g, "").toUpperCase()] || e, qr = (e, t) => {
  if (typeof e == "number" && Number.isFinite(e))
    return e;
  if (typeof e == "string" && e.trim()) {
    const r = Number(e);
    if (Number.isFinite(r))
      return r;
  }
  return t;
}, It = (e = []) => {
  const t = /* @__PURE__ */ new Set();
  let r = e.reduce((n, a) => {
    const i = Number(a == null ? void 0 : a.id);
    return Number.isFinite(i) ? Math.max(n, i + 1) : n;
  }, 1);
  return e.map((n) => {
    if (!n || typeof n != "object")
      return n;
    const a = n.id, i = a == null ? "" : String(a);
    if (i && !t.has(i))
      return t.add(i), n;
    for (; t.has(String(r)); )
      r += 1;
    const o = {
      ...n,
      id: r
    };
    return t.add(String(r)), r += 1, o;
  });
}, Us = (e) => {
  if (!e || typeof e != "object")
    return e;
  const { defaultState: t, ...r } = e;
  return r;
}, Hr = (e) => e ? Array.isArray(e) ? e.map((t) => ({
  concept: (t == null ? void 0 : t.concept) || {},
  includeDescendants: (t == null ? void 0 : t.includeDescendants) ?? (t == null ? void 0 : t.descendants) ?? !1,
  includeMapped: (t == null ? void 0 : t.includeMapped) ?? (t == null ? void 0 : t.mapped) ?? !1,
  isExcluded: (t == null ? void 0 : t.isExcluded) ?? (t == null ? void 0 : t.excluded) ?? !1,
  hierarchy: (t == null ? void 0 : t.hierarchy) ?? !1,
  id: t == null ? void 0 : t.id
})) : typeof e == "object" ? Object.values(e).map((t) => ({
  concept: (t == null ? void 0 : t.concept) || {},
  includeDescendants: (t == null ? void 0 : t.includeDescendants) ?? (t == null ? void 0 : t.descendants) ?? !1,
  includeMapped: (t == null ? void 0 : t.includeMapped) ?? (t == null ? void 0 : t.mapped) ?? !1,
  isExcluded: (t == null ? void 0 : t.isExcluded) ?? (t == null ? void 0 : t.excluded) ?? !1,
  hierarchy: (t == null ? void 0 : t.hierarchy) ?? !1,
  id: t == null ? void 0 : t.id
})) : [] : [], qe = (e) => Array.isArray(e) ? e.length > 0 : e && typeof e == "object" ? Object.keys(e).length > 0 : !1, ws = (e = []) => e.reduce((t, r, n) => {
  const a = qr(r == null ? void 0 : r.externalId, n);
  return [
    r == null ? void 0 : r.id,
    r == null ? void 0 : r.uuid,
    r == null ? void 0 : r.referenceId,
    r == null ? void 0 : r.externalId
  ].forEach((i) => {
    i != null && t.set(String(i), a);
  }), t;
}, /* @__PURE__ */ new Map()), Fs = {
  CodesetId: "CodesetId",
  DrugCodesetId: "DrugCodesetId",
  codesetId: "CodesetId",
  drugCodesetId: "DrugCodesetId"
}, nt = (e, t) => Array.isArray(e) ? e.map(
  (r) => nt(r, t)
) : !e || typeof e != "object" ? e : Object.keys(e).reduce((r, n) => {
  const a = e[n], i = Fs[n];
  if (i && a != null) {
    const o = t.has(
      String(a)
    ) ? t.get(String(a)) : a;
    return (n === i || e[i] == null) && (r[i] = o), r;
  }
  return r[n] = nt(a, t), r;
}, {}), Qr = (e) => {
  if (typeof e != "string")
    return e;
  const t = e.trim();
  if (!["{", "["].includes(t[0]))
    return e;
  try {
    return JSON.parse(t);
  } catch {
    return e;
  }
}, Se = (e) => {
  const t = Qr(e);
  return Array.isArray(t) ? t.map(Se) : !t || typeof t != "object" ? t : Array.isArray(t.CriteriaList) || Array.isArray(t.DemographicCriteriaList) || Array.isArray(t.Groups) ? Le(t) : Object.keys(t).reduce((r, n) => (r[n] = Se(t[n]), r), {});
}, Ls = (e) => {
  if (!e || typeof e != "object" || !e.Criteria)
    return Se(e);
  const t = Object.entries(e.Criteria);
  if (!t.length)
    return Se(e);
  const [r, n] = t[0], a = Ds(r);
  return {
    ...e,
    Criteria: {
      [a]: Se(n)
    }
  };
}, Rt = {
  hideOccurrence: !0,
  hideIgnoreObservationPeriod: !0,
  hiddenIgnoreObservationPeriodValue: !0,
  showRestrictToSameVisitForAllCriteria: !0
}, Xr = (e, t = {}) => {
  const r = Ls(e);
  if (!r || typeof r != "object")
    return r;
  const n = z(
    Object.keys(r.Criteria || {})[0]
  );
  if (!n)
    return r;
  const a = {
    ...r,
    StartWindow: r.StartWindow || Os()
  };
  return t.hideOccurrence ? delete a.Occurrence : a.Occurrence = r.Occurrence || Rs(), !t.hideIgnoreObservationPeriod && _s.has(n) || t.hiddenIgnoreObservationPeriodValue !== void 0 ? a.IgnoreObservationPeriod = t.hiddenIgnoreObservationPeriodValue ?? r.IgnoreObservationPeriod ?? n === Ss : delete a.IgnoreObservationPeriod, t.showRestrictToSameVisitForAllCriteria || bs.has(n) ? a.RestrictVisit = !!r.RestrictVisit : delete a.RestrictVisit, a;
};
function Le(e, t = {}) {
  const r = Qr(e), n = r && typeof r == "object" ? r : At;
  return {
    ...n,
    Type: n.Type || At.Type,
    CriteriaList: Array.isArray(n.CriteriaList) ? n.CriteriaList.map(
      (a) => Xr(a, t)
    ) : [],
    DemographicCriteriaList: Array.isArray(n.DemographicCriteriaList) ? n.DemographicCriteriaList.map(Se) : [],
    Groups: Array.isArray(n.Groups) ? n.Groups.map(
      (a) => Le(a, t)
    ) : []
  };
}
const Ps = (e) => {
  if (Array.isArray(e) || e && typeof e == "object")
    return e;
  if (typeof e != "string")
    return null;
  const t = e.trim();
  if (!t)
    return "";
  if (!["{", "["].includes(t[0]))
    return e;
  try {
    return JSON.parse(t);
  } catch {
    return e;
  }
}, He = (e) => {
  switch (e) {
    case L.DISTRIBUTION:
    case "distribution":
      return L.DISTRIBUTION;
    case L.CUSTOM:
    case "custom":
      return L.CUSTOM;
    case L.PREVALENCE:
    case "prevalence":
    default:
      return L.PREVALENCE;
  }
}, Ms = (e, t) => {
  if (e.type === xe.CUSTOM_FE)
    return L.CUSTOM;
  const r = z(e.statType || e.analysisType);
  if (r)
    return He(r);
  if (t && typeof t == "object" && !Array.isArray(t)) {
    if (t.analysisType)
      return He(t.analysisType);
    if (t.distributeBy || Array.isArray(t.criteriaGroups) && t.criteriaGroups.some(
      (n) => z(n == null ? void 0 : n.distributeBy)
    ))
      return L.DISTRIBUTION;
  }
  return Array.isArray(t) && t.some(
    (n) => z(n == null ? void 0 : n.distributeBy)
  ) ? L.DISTRIBUTION : L.PREVALENCE;
}, Bs = (e, t, r) => {
  var n;
  return e.type === xe.CUSTOM_FE ? k.CUSTOM_SQL : e.type === xe.CRITERIA_SET ? k.CRITERIA_SET : t === L.CUSTOM ? k.CUSTOM_SQL : Array.isArray((n = e == null ? void 0 : e.definition) == null ? void 0 : n.criteriaGroups) || Array.isArray(e == null ? void 0 : e.criteriaGroups) || Array.isArray(r) || r && typeof r == "object" && Array.isArray(r.criteriaGroups) ? k.CRITERIA_SET : k.PRESET;
}, Jr = (e, t, r, n) => {
  if (t === L.CUSTOM)
    return k.CUSTOM_SQL;
  switch (e) {
    case k.CRITERIA_SET:
      return k.CRITERIA_SET;
    case k.CUSTOM_SQL:
      return k.CUSTOM_SQL;
    case k.PRESET:
      return k.PRESET;
    default:
      return Bs(r, t, n);
  }
}, Kr = (e) => {
  var t;
  return ((t = kt[e]) == null ? void 0 : t.defaultDistributeBy) || oe.EVENTS_COUNT;
}, Zr = (e) => {
  const t = z(e).replace(/[^a-zA-Z]/g, "").toUpperCase();
  return ["EVENTSCOUNT", "EVENTCOUNT", "EVENTS"].includes(t);
}, en = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1_$2").replace(/[^a-zA-Z0-9]+/g, "_").replace(/^_+|_+$/g, "").toLowerCase(), je = (e) => {
  const t = z(e);
  return Zr(t) ? oe.EVENTS_COUNT : en(t).toUpperCase();
}, Vs = (e) => en(z(e)), mt = (e) => {
  const t = je(e) || oe.EVENTS_COUNT;
  if (t === oe.EVENTS_COUNT)
    return {
      function: "COUNT",
      additionalColumns: [],
      expression: "*"
    };
  if (t === zr)
    return {
      function: "COUNT",
      additionalColumns: [Wr],
      expression: gt
    };
  const r = t.split("_"), n = r[r.length - 1], a = vs[n], i = a ? r.slice(0, -1).join("_") : t;
  return {
    function: a ?? null,
    additionalColumns: i ? [i] : [],
    expression: Vs(i)
  };
}, ks = (e) => {
  if (!e || typeof e != "object")
    return "";
  const t = z(e.function).toUpperCase(), r = Array.isArray(e.additionalColumns) ? je(e.additionalColumns[0]) : "", n = je(
    e.expression
  ), a = r || n;
  if (t === "COUNT" && (!a || Zr(a)))
    return oe.EVENTS_COUNT;
  if (t === "COUNT" && r === Wr && (z(e.expression).trim().toUpperCase() === gt.toUpperCase() || n === je(gt)))
    return zr;
  if (!a)
    return "";
  switch (t) {
    case "AVG":
      return `${a}_AVERAGE`;
    case "MAX":
      return `${a}_MAX`;
    case "MIN":
      return `${a}_MIN`;
    default:
      return a;
  }
}, tn = (e) => {
  const t = [...e.CriteriaList], r = [...e.DemographicCriteriaList];
  return e.Groups.forEach((n) => {
    const a = tn(n);
    t.push(...a.criteriaItems), r.push(...a.demographicCriteriaItems);
  }), { criteriaItems: t, demographicCriteriaItems: r };
}, $s = (e, t = /* @__PURE__ */ new Map()) => {
  const r = Yt(
    e,
    t,
    Rt
  ), n = Le(
    r.expression,
    Rt
  ), a = je(e == null ? void 0 : e.distributeBy) || oe.EVENTS_COUNT, i = Object.keys(r).reduce((A, E) => (["criteriaType", "distributeBy", "expression"].includes(E) || (A[E] = r[E]), A), {}), { criteriaItems: o, demographicCriteriaItems: c } = tn(n), m = o.map((A) => {
    const {
      Occurrence: E,
      mapDistinctField: g,
      ...O
    } = A;
    return {
      ...i,
      criteriaType: rt,
      aggregate: mt(a),
      expression: O
    };
  }), p = c.map(
    (A) => ({
      ...i,
      criteriaType: Gt,
      aggregate: mt(
        oe.EVENTS_COUNT
      ),
      expression: A
    })
  );
  return !m.length && !p.length ? [
    {
      ...i,
      criteriaType: rt,
      aggregate: mt(a),
      expression: n
    }
  ] : [...m, ...p];
}, Yt = (e, t = /* @__PURE__ */ new Map(), r = {}) => {
  if (!e || typeof e != "object")
    return {
      criteriaType: xt,
      expression: nt(
        Le(e, r),
        t
      )
    };
  const n = Us(e), a = z(n.criteriaType) || xt, i = n.expression && typeof n.expression == "object" ? n.expression : n;
  return {
    ...n,
    criteriaType: a,
    expression: nt(
      Le(i, r),
      t
    )
  };
}, Gs = (e, t) => {
  const {
    aggregate: r,
    criteriaType: n,
    expression: a,
    ...i
  } = e || {}, o = z(e == null ? void 0 : e.criteriaType), c = e != null && e.expression && typeof e.expression == "object" ? e.expression : {}, m = ks(e == null ? void 0 : e.aggregate) || oe.EVENTS_COUNT, p = {
    ...At,
    CriteriaList: o === rt ? [
      Xr(
        c,
        Rt
      )
    ] : [],
    DemographicCriteriaList: o === Gt ? [Se(c)] : []
  };
  return {
    ...i,
    criteriaType: xt,
    distributeBy: m,
    name: z(e == null ? void 0 : e.name) || z(e == null ? void 0 : e.title) || `Criteria group ${t + 1}`,
    description: z(e == null ? void 0 : e.description),
    expression: p,
    defaultState: !1
  };
}, mr = (e, t) => {
  if ([
    rt,
    Gt
  ].includes(z(e == null ? void 0 : e.criteriaType)))
    return Gs(e, t);
  const r = Yt(e);
  return {
    ...r,
    name: z(r.name) || z(e == null ? void 0 : e.title) || `Criteria group ${t + 1}`,
    description: z(r.description),
    expression: Le(r.expression),
    defaultState: !1
  };
}, rn = (e, t, r) => {
  if (t !== L.DISTRIBUTION)
    return e;
  const n = r || Kr(t);
  return e.map((a) => {
    if (!Gr(a)) {
      const { distributeBy: m, ...p } = a;
      return p;
    }
    const i = Yr(
      a
    ).map((m) => m.value), o = je(
      a.distributeBy
    ), c = i.includes(n) ? n : oe.EVENTS_COUNT;
    return {
      ...a,
      distributeBy: i.includes(o) ? o : c
    };
  });
}, zt = (e) => {
  var i;
  if (!e || typeof e != "object")
    return null;
  const t = [
    e.uuid,
    e.referenceId,
    e.id
  ].find(dr), r = [e.versionId, e.currentVersionId].find(
    dr
  );
  if (!t || !r)
    return null;
  const n = qe((i = e.expression) == null ? void 0 : i.items) ? e.expression.items : e.items || [];
  return {
    id: e.externalId !== void 0 && e.externalId !== null ? e.externalId : e.id,
    name: e.name || "New Concept set",
    expression: {
      ...e.expression,
      items: Hr(n)
    },
    uuid: e.uuid || t,
    referenceId: t,
    externalId: e.externalId,
    versionId: r,
    currentVersionId: e.currentVersionId || r,
    version: e.version,
    versionOrdinal: e.versionOrdinal || e.version,
    currentVersionOrdinal: e.currentVersionOrdinal || e.versionOrdinal || e.version,
    terminated: e.terminated
  };
}, Ys = (e, t = 0) => {
  var i;
  const r = zt(e);
  if (r)
    return r;
  if (!e || typeof e != "object")
    return null;
  const n = qe((i = e.expression) == null ? void 0 : i.items) ? e.expression.items : e.items || [];
  return qe(n) ? {
    id: ve(
      e.externalId ?? e.id ?? e.uuid ?? t
    ),
    name: Oe(e.name) || Oe(e.title) || "New Concept set",
    expression: {
      ...e.expression,
      items: Hr(n)
    },
    uuid: Oe(e.uuid) || void 0,
    referenceId: Oe(e.referenceId) || void 0,
    externalId: ve(e.externalId ?? e.id),
    versionId: Oe(e.versionId) || void 0,
    currentVersionId: Oe(e.currentVersionId) || Oe(e.versionId) || void 0,
    version: ve(e.version),
    versionOrdinal: ve(
      e.versionOrdinal ?? e.version
    ),
    currentVersionOrdinal: ve(
      e.currentVersionOrdinal ?? e.versionOrdinal ?? e.version
    ),
    terminated: e.terminated
  } : null;
}, nn = (e, t = []) => (!e || typeof e != "object" || (Array.isArray(e.ConceptSets) && t.push(...e.ConceptSets), Array.isArray(e.Groups) && e.Groups.forEach(
  (r) => nn(r, t)
)), t), zs = (e = []) => e.flatMap(
  (t, r) => nn(t == null ? void 0 : t.expression).map(
    (n, a) => Ys(n, r + a)
  )
), Ws = (e = []) => {
  const t = /* @__PURE__ */ new Set(), r = [];
  return e.forEach((n) => {
    var i, o;
    if (!n)
      return;
    const a = String(
      n.externalId ?? n.id ?? n.uuid ?? n.referenceId ?? n.name
    );
    if (t.has(a)) {
      const c = r.findIndex(
        (E) => String(
          E.externalId ?? E.id ?? E.uuid ?? E.referenceId ?? E.name
        ) === a
      ), m = r[c], p = qe((i = n == null ? void 0 : n.expression) == null ? void 0 : i.items), A = qe(
        (o = m == null ? void 0 : m.expression) == null ? void 0 : o.items
      );
      p && !A && (r[c] = {
        ...n,
        ...m,
        expression: n.expression
      });
      return;
    }
    t.add(a), r.push(n);
  }), r;
}, qs = (e, t) => {
  const r = zt(e);
  return r ? {
    id: r.referenceId,
    versionId: r.versionId,
    externalId: qr(r.externalId, t)
  } : null;
}, Ye = () => ({
  id: $t,
  name: "",
  description: "",
  domain: "",
  analysisType: L.PREVALENCE,
  subtype: k.CRITERIA_SET,
  definition: {
    criteriaGroups: [],
    sql: "",
    distributeBy: ""
  },
  conceptSets: [],
  raw: {}
}), me = (e) => {
  var x, y, f;
  if (!e)
    return Ye();
  const t = Ps(e.design), r = e.type ? Ms(e, t) : He(e.analysisType || e.statType), n = Jr(
    e.subtype || e.featureSubtype || e.faType,
    r,
    e,
    t
  ), a = t && typeof t == "object" && !Array.isArray(t) ? t : null, i = Array.isArray(t) ? t : Array.isArray(a == null ? void 0 : a.criteriaGroups) ? a.criteriaGroups : [], o = Array.isArray((x = e == null ? void 0 : e.definition) == null ? void 0 : x.criteriaGroups) ? e.definition.criteriaGroups : Array.isArray(e == null ? void 0 : e.criteriaGroups) ? e.criteriaGroups : [], c = i.length > 0 ? i.map(mr) : o.map(mr), m = It(c), p = z(
    ((y = e == null ? void 0 : e.definition) == null ? void 0 : y.distributeBy) || e.distributeBy || (a ? a.distributeBy : "")
  ) || (r === L.DISTRIBUTION ? Kr(r) : ""), A = z(
    ((f = e == null ? void 0 : e.definition) == null ? void 0 : f.sql) || (e == null ? void 0 : e.sql) || (typeof t == "string" ? t : "")
  ), E = Array.isArray(e == null ? void 0 : e.conceptSets) ? e.conceptSets.map(zt) : [], g = zs(
    m
  ), O = Ws([
    ...E,
    ...g
  ]), S = z(e.shortcut);
  return {
    id: z(e.id) || $t,
    ...S ? { shortcut: S } : {},
    name: z(e.name),
    description: z(e.description),
    domain: z(e.domain),
    analysisType: r,
    subtype: n,
    definition: {
      criteriaGroups: rn(
        m,
        r,
        p
      ),
      sql: A,
      distributeBy: p
    },
    conceptSets: O,
    created: e.created,
    modified: e.modified,
    actions: e.actions,
    versionId: e.versionId,
    raw: e
  };
}, de = (e) => {
  var A, E;
  const t = He(e.analysisType), r = Jr(e.subtype, t, {
    ...e.raw
  }), n = xs(r), a = ws(
    e.conceptSets || []
  ), i = rn(
    It(e.definition.criteriaGroups || []),
    t,
    e.definition.distributeBy
  ), o = It(
    t === L.DISTRIBUTION ? i.flatMap(
      (g) => $s(
        g,
        a
      )
    ) : i.map(
      (g) => Yt(
        g,
        a
      )
    )
  ), c = (e.conceptSets || []).map(qs).filter(Boolean), m = r === k.CUSTOM_SQL ? L.PREVALENCE : t, p = {
    ...e.raw,
    id: e.id === $t ? void 0 : e.id,
    name: (A = e.name) == null ? void 0 : A.trim(),
    description: e.description || "",
    domain: e.domain || "",
    type: n,
    analysisType: t,
    statType: m,
    subtype: r,
    featureSubtype: r,
    definition: {
      ...((E = e.raw) == null ? void 0 : E.definition) || {},
      criteriaGroups: [],
      sql: "",
      distributeBy: ""
    },
    design: null,
    conceptSets: []
  };
  return n === xe.CUSTOM_FE ? (p.design = e.definition.sql || "", p.definition.sql = e.definition.sql || "", p.sql = e.definition.sql || "", p.definition.criteriaGroups = [], p.criteriaGroups = [], p.conceptSets = null, p.distributeBy = "") : (p.design = o, p.definition.criteriaGroups = o, p.criteriaGroups = o, p.definition.distributeBy = void 0, p.distributeBy = void 0, p.definition.sql = "", p.sql = "", p.conceptSets = c), p;
}, pt = (e, t) => JSON.stringify(e) === JSON.stringify(t), Hs = (e, t) => {
  const r = de(e), n = de(t), a = {};
  [
    "name",
    "description",
    "domain",
    "type",
    "analysisType",
    "statType",
    "subtype",
    "featureSubtype"
  ].forEach((o) => {
    pt(r[o], n[o]) || (a[o] = n[o]);
  }), pt(r.design, n.design) || (a.design = n.design);
  const i = !pt(
    r.conceptSets,
    n.conceptSets
  );
  return i && Array.isArray(n.design) && (a.design = n.design), (i || Array.isArray(a.design)) && (a.conceptSets = n.conceptSets), Array.isArray(a.design) && (a.definition = {
    ...n.definition || {},
    criteriaGroups: a.design
  }, a.criteriaGroups = a.design), a;
}, Wt = (e) => {
  const t = me(e), r = z(e == null ? void 0 : e.statType), n = r ? He(r) : t.analysisType, a = !!z((e == null ? void 0 : e.statType) || (e == null ? void 0 : e.analysisType));
  switch (n) {
    case L.DISTRIBUTION:
      return "Distribution";
    case L.CUSTOM:
      return "Custom";
    case L.PREVALENCE:
    default:
      return t.subtype === k.PRESET && !a ? "Preset" : "Prevalence";
  }
}, qt = (e) => {
  switch (me(e).subtype) {
    case k.CRITERIA_SET:
      return "Criteria Set";
    case k.CUSTOM_SQL:
      return "Custom SQL";
    case k.PRESET:
    default:
      return "Preset";
  }
}, sn = (e) => e.analysisType !== L.CUSTOM && e.subtype === k.CRITERIA_SET, Qs = (e) => e.analysisType === L.CUSTOM || e.subtype === k.CUSTOM_SQL, Xs = (e) => sn(e) && !Qs(e), Ot = (e, t) => {
  const r = t === L.CUSTOM ? k.CUSTOM_SQL : e.subtype === k.CUSTOM_SQL ? k.CRITERIA_SET : e.subtype, n = kt[t];
  return {
    ...e,
    analysisType: t,
    subtype: n.allowedSubtypes.includes(r) ? r : n.allowedSubtypes[0],
    definition: {
      ...e.definition,
      distributeBy: n.supportsDistributeBy ? e.definition.distributeBy || n.defaultDistributeBy : "",
      criteriaGroups: n.supportsCriteria ? e.definition.criteriaGroups || [] : [],
      sql: n.supportsSql && e.definition.sql || ""
    },
    conceptSets: n.supportsCriteria ? e.conceptSets || [] : []
  };
}, Js = (e) => {
  var t;
  return sn(e) ? Array.isArray((t = e.definition) == null ? void 0 : t.criteriaGroups) ? e.definition.criteriaGroups.length === 0 ? "Criteria definition has no criteria groups." : null : "Criteria definition is missing." : null;
}, Ks = (e) => {
  const t = me(e), r = Js(t);
  return { feature: t, error: r };
}, ge = "/draft-features", Zs = "prometheus:custom-features-changed", an = () => {
  typeof window < "u" && window.dispatchEvent(new Event(Zs));
}, ea = (e, t) => {
  const { pageNumber: r, pageSize: n, sortBy: a, query: i } = t, o = Mt(a);
  return `${e}?size=${n ?? ""}&page=${r ?? 0}&sort=${o}&${i || ""}`;
}, ta = (e, t) => {
  if (typeof e == "string")
    return e;
  if (e && typeof e == "object" && "id" in e && typeof e.id == "string")
    return e.id;
  throw new Error("Unable to resolve saved draft feature id");
}, Qe = (e) => ee.get(
  ea(`${ge}/list`, e)
), bt = (e) => ee.get(
  `${ge}/filter?${e}`
), on = () => ee.get(`${ge}/sorts`), Je = (e) => ee.get(`${ge}/${e}`), ra = (e, t) => ee.post(
  `${ge}/concept-sets/copy/${e}`,
  t ? { name: t } : {}
), De = async (e) => {
  const t = await ee.post(ge, e), r = ta(t), n = await Je(r);
  return an(), n;
}, na = async (e, t) => (await ee.patch(`${ge}/${e}`, t), Je(e)), ln = (e, t) => t !== "new" ? na(t, e) : De(e), un = async (e) => {
  await ee.delete(`${ge}/${e}`), an();
}, sa = async () => {
  var e;
  try {
    return await Qe({
      pageNumber: 0,
      pageSize: 1,
      sortBy: { id: "modified.timestamp", desc: !0 },
      query: ""
    }), !0;
  } catch (t) {
    return ![400, 403, 404, 405].includes((e = t == null ? void 0 : t.response) == null ? void 0 : e.status);
  }
}, aa = (e) => {
  const { draftFeatureId: t, message: r = "" } = e;
  if (!t)
    throw new Error("draft feature id is required for publish request");
  return ee.post(`${ge}/${t}/publish`, {
    message: r
  });
}, Ht = "/library/feature-analyses", cn = "/library/feature-analyses/custom", ia = [
  "/feature-analyses",
  "/feature-analysis",
  "/library/feature-analyses",
  "/library/feature-analysis"
], dn = (e, t) => {
  const { pageNumber: r, pageSize: n, sortBy: a, query: i } = t, o = Mt(a);
  return `${e}?size=${n ?? ""}&page=${r ?? 0}&sort=${o}&${i || ""}`;
}, oa = async (e) => {
  var r;
  let t = null;
  for (const n of e)
    try {
      return await ee.get(n);
    } catch (a) {
      t = a;
      const i = (r = a == null ? void 0 : a.response) == null ? void 0 : r.status;
      if (![400, 403, 404, 405].includes(i))
        throw a;
    }
  throw t;
}, Ze = (e) => ee.get(
  dn(`${Ht}/list`, e)
), mn = (e) => ee.get(
  `${Ht}/filter?${e}`
), pn = () => ee.get(
  `${Ht}/sorts`
), ut = (e) => oa(
  ia.map((t) => `${t}/${e}`)
), la = (e) => ee.get(
  dn(
    `${cn}/list`,
    e
  )
), ua = (e) => ee.get(
  `${cn}/filter?${e}`
), ca = async (e) => {
  var t;
  try {
    return await Je(e);
  } catch (r) {
    const n = (t = r == null ? void 0 : r.response) == null ? void 0 : t.status;
    if (![403, 404, 405].includes(n))
      throw r;
    return ut(e);
  }
}, yn = {
  workspace: "/workspace/feature-analyses/copy",
  study: (e) => `/studies/${e}/feature-analyses/copy`
}, da = (e, t) => {
  const { pageNumber: r, pageSize: n, sortBy: a, query: i } = t, o = Mt(a);
  return `${e}?size=${n ?? ""}&page=${r ?? 0}&sort=${o}&${i || ""}`;
}, Qt = (e, t) => ee.get(da(e, t)), Xt = (e, t) => ee.get(`${e}/filter?${t}`), fn = (e) => ee.get(`${e}/sorts`), Cn = (e) => Qt(
  "/workspace/feature-analyses/list",
  e
), En = (e, t) => Qt(
  `/studies/${e}/feature-analyses/list`,
  t
), ma = (e) => Qe(e), hn = (e) => Xt("/workspace/feature-analyses", e), Tn = (e, t) => Xt(`/studies/${t}/feature-analyses`, e), xn = () => fn("/workspace/feature-analyses"), Jt = (e, t) => Qt(`/feature-analyses/${e}/usage/list`, t), pa = (e, t) => Xt(`/feature-analyses/${t}/usage`, e), ya = (e) => fn(`/feature-analyses/${e}/usage`), gn = (e) => ee.get(`/conceptset/version/${e}`), fa = (e) => ee.get(`/conceptset/${e}`), An = (e, t) => ln(e, t), Ca = (e, t) => An(e, t), Ea = (e, t) => An(e, t), ha = (e) => {
  const t = e.featureAnalysisId || e.customFeatureId || e.featureId || e.analysisId;
  if (!t)
    throw new Error("feature id is required for publish request");
  return aa({
    draftFeatureId: t,
    message: e.message || ""
  });
}, In = (e) => {
  if (e && typeof e == "object" && "id" in e)
    return e;
  if (typeof e == "string")
    return { id: e };
}, pr = async (e, t, r = Pt.CREATE_NEW_OBJECT) => In(
  await ee.post(
    `${yn.workspace}/${e}?resolution=${encodeURIComponent(r)}`,
    t ? { name: t } : {}
  )
), Ta = async (e, t, r, n = Pt.CREATE_NEW_OBJECT) => In(
  await ee.post(
    `${yn.study(
      e
    )}/${t}?resolution=${encodeURIComponent(n)}`,
    r ? { name: r } : {}
  )
), xa = (e, t) => (r, n, a = Pt.COPY) => {
  switch (e) {
    case Z.STUDY:
      return Ta(t, r, n, a);
    case Z.WORKSPACE:
      return pr(r, n, a);
    default:
      return pr(r, n, a);
  }
}, ga = (e, t, r, n) => e.values[r] > t.values[r] ? 1 : t.values[r] > e.values[r] ? -1 : 0, Aa = {
  createCols: (e, t, r, n) => [
    {
      Header: "",
      accessor: "typeEntity",
      id: "typeEntityIcon",
      disableSortBy: !0,
      width: "3%",
      minWidth: 45,
      Cell: () => /* @__PURE__ */ s.jsx(Ce, { value: Ee.ANALYSIS, cell: !0, size: 28 })
    },
    jt(),
    ot({
      sortType: ga,
      Cell: (a) => {
        var i, o, c, m;
        return /* @__PURE__ */ s.jsx(
          Nt,
          {
            text: (o = (i = a.row) == null ? void 0 : i.original) == null ? void 0 : o.description,
            color: "primary",
            width: "auto",
            children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(Ft, { value: (m = (c = a.row) == null ? void 0 : c.original) == null ? void 0 : m.name }) })
          }
        );
      }
    }),
    {
      Header: "Domain",
      accessor: (a) => me(a).domain || "-",
      id: "domain"
    },
    {
      Header: "Type",
      accessor: (a) => Wt(a),
      id: "type"
    },
    {
      Header: "Subtype",
      accessor: (a) => qt(a),
      id: "subtype"
    },
    Dt(),
    Ut(),
    wt(),
    ...r ? n ? [
      {
        Header: "",
        accessor: "actions",
        isCropped: !0,
        maxWidth: 100,
        disableSortBy: !0,
        Cell: (a) => /* @__PURE__ */ s.jsx(
          ft,
          {
            onView: () => n(
              a.row.original.id || a.row.original.value
            )
          }
        )
      }
    ] : [] : [
      {
        Header: "",
        accessor: "actions",
        isCropped: !0,
        maxWidth: 100,
        disableSortBy: !0,
        Cell: (a) => /* @__PURE__ */ s.jsx(
          ft,
          {
            onRemove: () => t(
              a.row.original.id || a.row.original.value
            )
          }
        )
      }
    ]
  ]
}, Ia = (e, t) => e === K.CUSTOM_FEATURE_STORE ? Qe : t ? la : Ze, Ra = (e, t) => e === K.CUSTOM_FEATURE_STORE ? bt : t ? ua : mn, Oa = (e) => e === K.CUSTOM_FEATURE_STORE ? on : pn, ba = {
  loadingMessage: "Loading custom features...",
  createCrudMethod: (e, t, r = K.ARTIFACTS_LIBRARY, n) => ({
    fetch: (a, i, o, c) => {
      const m = Ia(r, n);
      if (r === K.CUSTOM_FEATURE_STORE)
        return m({
          pageNumber: a,
          pageSize: i,
          sortBy: o,
          query: c
        });
      switch (e) {
        case Z.STUDY:
          return En(t, {
            pageNumber: a,
            pageSize: i,
            sortBy: o,
            query: c
          });
        case Z.WORKSPACE:
          return Cn({
            pageNumber: a,
            pageSize: i,
            sortBy: o,
            query: c
          });
        default:
          return m({
            pageNumber: a,
            pageSize: i,
            sortBy: o,
            query: c
          });
      }
    }
  }),
  createFiltersPanel: (e, t, r = K.ARTIFACTS_LIBRARY, n) => {
    const a = Ra(r, n);
    return r === K.CUSTOM_FEATURE_STORE ? tt(
      e,
      t,
      a
    ) : tt(
      e,
      t,
      a,
      Tn,
      hn,
      a
    );
  },
  createSortingMethod(e, t = K.ARTIFACTS_LIBRARY) {
    const r = Oa(t);
    return Bt(e, {
      getSorting: r,
      getSortingWorkspace: xn
    });
  },
  cols: [
    Sr({
      Header: "",
      accessorFn: () => Ee.ANALYSIS,
      id: "typeEntityIcon",
      width: "2%",
      cell: Ce
    }),
    jt(),
    ot({
      width: "20%",
      cell: (e) => {
        var t, r, n, a;
        return /* @__PURE__ */ s.jsx(
          Nt,
          {
            text: (r = (t = e.row) == null ? void 0 : t.original) == null ? void 0 : r.description,
            color: "primary",
            width: "auto",
            children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(Ft, { value: (a = (n = e.row) == null ? void 0 : n.original) == null ? void 0 : a.name }) })
          }
        );
      }
    }),
    {
      header: "Domain",
      accessorFn: (e) => me(e).domain || "-",
      id: "domain"
    },
    {
      header: "Type",
      accessorFn: (e) => Wt(e),
      id: "type"
    },
    {
      header: "Subtype",
      accessorFn: (e) => qt(e),
      id: "subtype"
    },
    Dt(),
    Ut(),
    wt()
  ]
}, Rn = (e) => {
  const {
    onChange: t,
    typeContainer: r,
    parentId: n,
    isSelect: a,
    source: i = K.ARTIFACTS_LIBRARY,
    customStoreApiAvailable: o = !0,
    customStoreApiChecked: c = !0,
    showTitle: m = !0,
    customOnly: p = !1
  } = e, {
    createCrudMethod: A,
    createFiltersPanel: E,
    createSortingMethod: g,
    cols: O,
    loadingMessage: S
  } = ba, x = i === K.CUSTOM_FEATURE_STORE && c && !o, y = i === K.CUSTOM_FEATURE_STORE && !c, f = ne(
    () => ({
      fetch: async () => ({
        content: [],
        pageable: {
          offset: 0,
          pageNumber: 0,
          pageSize: 10,
          paged: !0,
          unpaged: !1,
          sort: { empty: !0, sorted: !1, unsorted: !0 }
        },
        empty: !0,
        first: !0,
        last: !0,
        number: 0,
        numberOfElements: 0,
        size: 10,
        sort: { empty: !0, sorted: !1, unsorted: !0 },
        totalElements: 0,
        totalPages: 1
      })
    }),
    []
  ), N = ne(() => x || y ? f : A(r, n, i, p), [
    A,
    p,
    f,
    y,
    x,
    n,
    i,
    r
  ]), I = et.useMemo(() => x || y ? {
    getFilters: async () => ({ items: [] })
  } : E(r, n, i, p), [
    E,
    p,
    y,
    x,
    n,
    i,
    r
  ]), j = et.useMemo(() => x || y ? async () => [] : g == null ? void 0 : g(r, i), [
    g,
    y,
    x,
    n,
    i,
    r
  ]), { selectedConcepts: U, detectSelectedAction: D, clear: W } = Bn(
    {},
    "id"
  ), {
    data: { tableData: d, filtersData: _ },
    filters: w,
    pageCount: M,
    pageSize: se,
    isLoading: J,
    getEntity: h,
    totalElements: F,
    updateFilters: V,
    allowedSorting: Y,
    status: te
  } = Vn(
    {
      get: N.fetch,
      remove: () => {
      },
      getFilters: I.getFilters,
      getSorting: j
    },
    "",
    !1
  ), $ = ne(
    () => ns(O, Y),
    [Y, O]
  ), l = (v) => {
    t(
      a ? Object.values(U).map((Q) => ({
        ...Q,
        source: i
      })) : [{ ...v.original, source: i }]
    );
  }, R = ye((v, Q) => {
    const ue = {};
    v == null || v.forEach((G) => {
      ue[G.id] = G;
    }), D(ue, Q);
  }, []), P = Object.keys(U).length, { otherFilters: q, searchFilter: H } = ss(_);
  return /* @__PURE__ */ s.jsx(C, { container: !0, children: /* @__PURE__ */ s.jsxs(st, { elevated: !0, outlined: !0, children: [
    m && /* @__PURE__ */ s.jsx(
      Gn,
      {
        title: i === K.CUSTOM_FEATURE_STORE ? "Custom Features Store" : "Artifacts Library",
        startIcon: /* @__PURE__ */ s.jsx(fe, { iconName: "list" })
      }
    ),
    /* @__PURE__ */ s.jsxs(
      C,
      {
        container: !0,
        className: "table-list-features-widget",
        pb: P ? 4 : 0,
        children: [
          /* @__PURE__ */ s.jsx(
            qn,
            {
              onAdd: () => {
                l();
              },
              onClear: W,
              selectedConceptsCount: P,
              buttonText: "Add feature to analysis",
              width: P != null ? "calc(100% - 250px)" : window.innerWidth - 250 + "px"
            }
          ),
          /* @__PURE__ */ s.jsxs(C, { item: !0, xs: 12, p: 2, children: [
            y && /* @__PURE__ */ s.jsxs(C, { item: !0, xs: 12, py: 4, textAlign: "center", children: [
              /* @__PURE__ */ s.jsx(fe, { iconName: "list", sx: { mb: 1, fontSize: 28 } }),
              /* @__PURE__ */ s.jsx("div", { children: "Checking Custom Features Store availability..." })
            ] }),
            x && /* @__PURE__ */ s.jsxs(C, { item: !0, xs: 12, py: 4, textAlign: "center", children: [
              /* @__PURE__ */ s.jsx(fe, { iconName: "info", sx: { mb: 1, fontSize: 28 } }),
              /* @__PURE__ */ s.jsx("div", { children: "Custom Features Store UI is ready, but backend API is not available yet." }),
              /* @__PURE__ */ s.jsxs("div", { children: [
                "Required endpoints: GET /api/draft-features/list, GET /api/draft-features/filter, GET /api/draft-features/sorts, GET /api/draft-features/",
                "{id}",
                ", POST /api/draft-features/concept-sets/copy/",
                "{id}",
                "."
              ] })
            ] }),
            !y && !x && /* @__PURE__ */ s.jsx(
              Yn,
              {
                enableRowSelection: a,
                variant: "controlled",
                noDataText: "No data currently available",
                data: d,
                columns: $,
                pageCount: M,
                pageSize: se,
                loading: J,
                loadingMessage: S,
                fetchData: h,
                totalElements: F,
                selectedRowIds: U,
                onRowSelect: R,
                onRowClick: a ? () => {
                } : l,
                getRowId: (v) => String(v.id),
                showFilterToggle: !0,
                searchComponent: H && /* @__PURE__ */ s.jsx(
                  Wn,
                  {
                    ...H,
                    value: w == null ? void 0 : w[H == null ? void 0 : H.name],
                    onChange: (v) => V({ [H == null ? void 0 : H.name]: v })
                  }
                ),
                children: /* @__PURE__ */ s.jsx(
                  zn,
                  {
                    showLabel: !0,
                    filters: q,
                    value: w,
                    onChange: (v, Q) => V({ [v]: Q }),
                    isLoading: te === ae.IN_PROGRESS,
                    isReloading: te === ae.IN_PROGRESS_RELOAD
                  }
                )
              }
            )
          ] })
        ]
      }
    )
  ] }) });
};
var he = /* @__PURE__ */ ((e) => (e.GET_COHORTS = "GET_COHORTS", e.SET_COHORTS = "SET_COHORTS", e.REMOVE_COHORT = "REMOVE_COHORT", e.CREATE_COHORT_REQUEST = "CREATE_COHORTS_REQUEST", e.CREATE_COHORT_REQUEST_DONE = "CREATE_COHORTS_REQUEST_DONE", e.CLEAR = "CLEAR", e))(he || {});
const _a = {
  isCreated: !1,
  isUpdate: !1,
  isLoading: !1,
  features: {}
}, Sa = (e, t) => as(e, (r) => {
  switch (t.type) {
    case he.GET_COHORTS:
      r.features = t.payload;
      break;
    case he.CREATE_COHORT_REQUEST:
      r.isCreated = !1, r.isUpdate = !1, r.isLoading = !0;
      break;
    case he.CREATE_COHORT_REQUEST_DONE:
      r.isCreated = !0, r.isLoading = !1;
      break;
    case he.CLEAR:
      r.features = {};
      break;
    case he.SET_COHORTS:
      r.features = t.payload;
      break;
    case he.REMOVE_COHORT:
      delete r.features[t.payload];
      break;
  }
}), va = () => {
  const [e, t] = Pn(
    Sa,
    _a
  ), r = ye(
    async (i) => {
      try {
        const o = [];
        i.forEach((p) => {
          o.push(ca(p));
        });
        const c = await Promise.all(o), m = {};
        return c.forEach((p) => {
          const A = me(p);
          m[p.id] = {
            value: p.id,
            id: p.id,
            name: A.name,
            description: A.description,
            domain: A.domain,
            analysisType: A.analysisType,
            subtype: A.subtype,
            // Keep the audit info: the list renders Created/Updated/Author
            // columns off `created.timestamp`, `modified.timestamp` and
            // `created.user.name`.
            created: A.created,
            modified: A.modified
          };
        }), t({
          type: he.GET_COHORTS,
          payload: m
        }), m;
      } catch {
      }
    },
    [e.features]
  ), n = ye((i, o) => {
    t({
      type: he.SET_COHORTS,
      payload: i
    });
  }, []), a = ye(async (i) => {
    t({
      type: he.REMOVE_COHORT,
      payload: i
    });
  }, []);
  return {
    ...e,
    getExistFeatureById: r,
    setFeatureByImport: n,
    removeFeature: a
  };
}, Na = [
  K.ARTIFACTS_LIBRARY,
  K.CUSTOM_FEATURE_STORE
], ja = (e) => {
  var t, r, n;
  return ((r = (t = e == null ? void 0 : e.response) == null ? void 0 : t.data) == null ? void 0 : r.message) || ((n = e == null ? void 0 : e.response) == null ? void 0 : n.statusText) || (e == null ? void 0 : e.message) || "Import failed";
}, Da = ({
  isSelect: e,
  onChange: t,
  availableSources: r = Na
}) => {
  const [n, a] = X("loading"), i = ne(
    () => r.filter(
      (p) => p !== K.CUSTOM_FEATURE_STORE || n === "available"
    ),
    [r, n]
  ), [o, c] = X(
    K.ARTIFACTS_LIBRARY
  );
  pe(() => {
    if (!r.includes(K.CUSTOM_FEATURE_STORE)) {
      a("unavailable");
      return;
    }
    let p = !0;
    return sa().then((A) => {
      p && a(A ? "available" : "unavailable");
    }).catch(() => {
      p && a("unavailable");
    }), () => {
      p = !1;
    };
  }, [r]), pe(() => {
    i.includes(o) || c(
      i[0] || K.ARTIFACTS_LIBRARY
    );
  }, [o, i]);
  const m = ne(() => i.map((p) => ({
    value: p,
    title: p === K.CUSTOM_FEATURE_STORE ? "Custom Features Store" : "Artifacts Library",
    onTabClick: c
  })), [i]);
  return /* @__PURE__ */ s.jsxs(C, { container: !0, children: [
    m.length > 0 && /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(br, { elevation: 3, sx: { zIndex: 2, px: 2, width: "100%" }, children: /* @__PURE__ */ s.jsx(
      lt,
      {
        tabs: m,
        active: o
      }
    ) }) }),
    /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(
      Rn,
      {
        source: o,
        isSelect: e,
        onChange: t,
        typeContainer: null,
        parentId: null,
        showTitle: !1,
        customStoreApiAvailable: n === "available",
        customStoreApiChecked: n !== "loading"
      }
    ) })
  ] });
}, Ua = (e) => {
  var te;
  const {
    titleText: t,
    buttonText: r,
    onChange: n,
    initialData: a,
    isSelect: i,
    viewMode: o,
    classNameContainer: c = "feature-import-button",
    defaultState: m,
    availableSources: p,
    modalTitle: A,
    footer: E,
    returnEntityText: g
  } = e, { createCols: O } = Aa, { openModal: S, closeModal: x } = Te(vt), { enqueueSnackbar: y } = at(), f = Xe(), N = Ir(), [I, j] = X(!1), [U, D] = X(!1), { getExistFeatureById: W, features: d, setFeatureByImport: _, removeFeature: w } = va(), M = ye(
    ($) => {
      const l = d[$], R = l == null ? void 0 : l.source, P = encodeURIComponent(
        N.pathname + N.search
      ), q = encodeURIComponent(g || ""), H = R === K.CUSTOM_FEATURE_STORE ? `/library/custom-features/${$}` : `/library/feature-analyses/${$}`;
      f(
        `${H}?returnPath=${P}&returnEntityText=${q}`
      );
    },
    [d, N, f, g]
  ), se = ne(() => O(
    null,
    async ($) => {
      await w($);
      const l = { ...d };
      delete l[$], n(Object.keys(l));
    },
    o,
    o ? M : void 0
  ), [d, n, w, o, M]), J = xr(void 0), h = async ($) => {
    const R = (Array.isArray($) ? $ : []).filter(Boolean).filter(
      (v) => (v == null ? void 0 : v.id) && !Object.prototype.hasOwnProperty.call(d, v.id)
    );
    if (R.length === 0) {
      x();
      return;
    }
    x(), D(!0);
    const P = [];
    for (const v of R)
      try {
        const Q = (v == null ? void 0 : v.source) === K.CUSTOM_FEATURE_STORE ? await Je(v.id) : await ut(v.id), { feature: ue, error: G } = Ks(Q);
        if (G) {
          const ce = ue.name || v.name || "unknown", Ie = ue.id || v.id;
          y({
            message: `Cannot import analysis, due to invalid Criteria set Feature analysis (id: ${Ie}, name: ${ce}). ${G}`,
            variant: "error"
          });
          continue;
        }
        P.push({ feature: ue, source: v.source });
      } catch (Q) {
        y({
          message: `${v.name || v.id}: ${ja(Q)}`,
          variant: "error"
        });
      }
    const q = P.reduce(
      (v, { feature: Q, source: ue }) => (v[Q.id] = {
        value: Q.id,
        id: Q.id,
        name: Q.name,
        description: Q.description,
        domain: Q.domain,
        analysisType: Q.analysisType,
        subtype: Q.subtype,
        source: ue,
        created: Q.created,
        modified: Q.modified
      }, v),
      {}
    ), H = { ...d, ...q };
    _(H, i), n(Object.keys(H)), D(!1);
  };
  J.current = h;
  const F = ye(($) => {
    var l;
    return (l = J.current) == null ? void 0 : l.call(J, $);
  }, []), V = () => {
    S(
      () => /* @__PURE__ */ s.jsx(C, { container: !0, p: 2, children: /* @__PURE__ */ s.jsx(
        Da,
        {
          isSelect: i,
          onChange: F,
          availableSources: p
        }
      ) }),
      A || "Import custom features",
      {
        onClose: x,
        closeOnClickOutside: !0
      }
    );
  }, Y = ($) => {
    $ == null || $.stopPropagation(), V();
  };
  return pe(() => {
    if (a && a.length > 0) {
      j(!0);
      const $ = [];
      Object.keys(d).forEach((R) => {
        a.includes(d[R].id) && $.push(d[R].id);
      });
      const l = a.filter(
        (R) => !$.includes(R)
      );
      l.length > 0 ? W(l).finally(
        () => j(!1)
      ) : j(!1);
    } else
      j(!1);
  }, [d, W, a]), /* @__PURE__ */ s.jsx(
    it,
    {
      collapsible: !0,
      title: t,
      defaultState: m,
      elevated: !0,
      outlined: !0,
      actions: !o && /* @__PURE__ */ s.jsx(C, { item: !0, children: /* @__PURE__ */ s.jsx(
        Ae,
        {
          onClick: Y,
          variant: "contained",
          color: "info",
          startIcon: U ? /* @__PURE__ */ s.jsx(Ue, { size: 16 }) : /* @__PURE__ */ s.jsx(fe, { iconName: "add" }),
          name: `button-${c}`,
          disabled: U,
          children: r
        }
      ) }),
      children: /* @__PURE__ */ s.jsxs(C, { container: !0, className: c, mt: -1, children: [
        Object.keys(d).length > 0 ? /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, className: `table-${c}`, children: /* @__PURE__ */ s.jsx(
          Or,
          {
            columns: se,
            data: Object.keys(d).map(($) => d[$]),
            totalElements: (te = Object.keys(d)) == null ? void 0 : te.length,
            isLoading: I,
            loadingMessage: "",
            enableSorting: !0,
            enablePagination: !0
          }
        ) }) : /* @__PURE__ */ s.jsx(
          C,
          {
            item: !0,
            xs: 12,
            sx: {
              backgroundColor: "backgroundColor.main",
              textAlign: "center",
              p: 1,
              mt: 1
            },
            children: /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", color: "borderColor.main", children: "No custom features" })
          }
        ),
        Object.keys(d).length === 0 && I && /* @__PURE__ */ s.jsx(Fe, { children: /* @__PURE__ */ s.jsx(Ue, { size: 32 }) }),
        E && /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: E })
      ] })
    }
  );
}, wa = {
  createCols: (e, t, r) => {
    const n = [
      {
        Header: "Name",
        accessor: "name",
        id: "name"
      },
      {
        Header: "Value",
        accessor: "value",
        id: "value"
      }
    ];
    return r || n.push({
      Header: "",
      accessor: "actions",
      isCropped: !0,
      maxWidth: 100,
      disableSortBy: !0,
      Cell: (a) => /* @__PURE__ */ s.jsx(
        ft,
        {
          onRemove: () => t(a.row.original.id)
        }
      )
    }), n;
  }
}, yr = (e) => Array.isArray(e) ? e.reduce((t, r) => {
  const n = (r == null ? void 0 : r.id) || Ge();
  return t[n] = {
    id: n,
    ...r
  }, t;
}, {}) : e && typeof e == "object" ? e : {}, Fa = (e) => {
  const {
    onChange: t,
    initialParams: r,
    titleText: n,
    viewMode: a,
    defaultState: i,
    embedded: o
  } = e, { createCols: c } = wa, [m, p] = X(() => yr(r)), [A, E] = X(!1), g = xr(!1);
  pe(() => {
    const d = yr(r);
    p((_) => g.current ? (g.current = !1, Object.keys(_).reduce(
      (w, M) => {
        var h, F, V, Y;
        const se = (F = (h = _[M]) == null ? void 0 : h.name) == null ? void 0 : F.trim(), J = (Y = (V = _[M]) == null ? void 0 : V.value) == null ? void 0 : Y.trim();
        return !d[M] && (!se || !J) && (w[M] = _[M]), w;
      },
      { ...d }
    )) : d);
  }, [r]);
  const O = ne(() => c(
    null,
    async (d) => {
      const _ = { ...m };
      delete _[d], p(_), t(_);
    },
    a
  ), [m, a]), S = (d) => {
    g.current = !0, t(
      Object.keys(d).reduce((_, w) => {
        var J, h, F, V;
        const M = (h = (J = d[w]) == null ? void 0 : J.name) == null ? void 0 : h.trim(), se = (V = (F = d[w]) == null ? void 0 : F.value) == null ? void 0 : V.trim();
        return M && se && (_[w] = {
          ...d[w],
          name: M,
          value: se
        }), _;
      }, {})
    );
  }, x = (d) => {
    d == null || d.stopPropagation();
    const _ = Ge();
    p({
      ...m,
      [_]: {
        id: _,
        name: "",
        value: ""
      }
    });
  }, y = (d, _, w) => {
    const M = {
      ...m,
      [d]: {
        ...m[d],
        [_]: w
      }
    };
    p(M), S(M);
  }, f = (d) => {
    const _ = { ...m };
    delete _[d], p(_), S(_);
  }, N = Object.keys(m), I = N.length > 0, j = I && /* @__PURE__ */ s.jsx(C, { container: !0, spacing: 1.5, children: N.map((d) => {
    var _, w;
    return /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, md: 6, children: /* @__PURE__ */ s.jsxs(ie, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
      /* @__PURE__ */ s.jsxs(
        ie,
        {
          sx: {
            display: "flex",
            gap: 1,
            flex: 1,
            minWidth: 0,
            flexWrap: { xs: "wrap", sm: "nowrap" }
          },
          children: [
            /* @__PURE__ */ s.jsx(ie, { sx: { flex: "1 1 140px", minWidth: 0 }, children: /* @__PURE__ */ s.jsx(
              we,
              {
                name: `parameter-name-${d}`,
                type: "text",
                size: "medium",
                value: ((_ = m[d]) == null ? void 0 : _.name) || "",
                placeholder: "@parameter_name",
                onChange: (M) => y(d, "name", M.target.value),
                fullWidth: !0
              }
            ) }),
            /* @__PURE__ */ s.jsx(ie, { sx: { flex: "1 1 140px", minWidth: 0 }, children: /* @__PURE__ */ s.jsx(
              we,
              {
                name: `parameter-value-${d}`,
                type: "text",
                size: "medium",
                value: ((w = m[d]) == null ? void 0 : w.value) || "",
                placeholder: "parameter_value",
                onChange: (M) => y(d, "value", M.target.value),
                fullWidth: !0
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(Hn, { onRemove: () => f(d) })
    ] }) }, d);
  }) }), U = I && /* @__PURE__ */ s.jsx(C, { container: !0, children: /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, className: "table-features", children: /* @__PURE__ */ s.jsx(
    Or,
    {
      columns: O,
      data: N.map((d) => m[d]),
      isLoading: A,
      loadingMessage: "",
      enableSorting: !0,
      enablePagination: !0,
      showColumnToggle: !0
    }
  ) }) }), D = !I && A && /* @__PURE__ */ s.jsx(Fe, { children: /* @__PURE__ */ s.jsx(Ue, { size: 32 }) }), W = !a && /* @__PURE__ */ s.jsx(
    Ae,
    {
      onClick: x,
      variant: "text",
      color: "info",
      size: "small",
      startIcon: /* @__PURE__ */ s.jsx(fe, { iconName: "add", fontSize: "small" }),
      name: "add-parameter",
      sx: { px: 0.5 },
      children: "Add parameter"
    }
  );
  return o ? (
    // No top gap in edit mode: "+ Add parameter" sits directly under the
    // feature table instead of leaving an empty row (Andrej's review). View
    // mode keeps a little separation before the labelled parameters table.
    /* @__PURE__ */ s.jsxs(ie, { sx: { mt: a ? 2 : 0 }, children: [
      a ? I && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", sx: { mb: 1 }, children: "Feature analyses parameters" }),
        U
      ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(ie, { sx: { mb: I ? 1 : 0 }, children: W }),
        j
      ] }),
      D
    ] })
  ) : /* @__PURE__ */ s.jsxs(
    it,
    {
      collapsible: !0,
      title: n || "Feature analyses parameters",
      defaultState: i,
      elevated: !0,
      outlined: !0,
      actions: !a && /* @__PURE__ */ s.jsx(C, { item: !0, children: /* @__PURE__ */ s.jsx(
        Ae,
        {
          onClick: x,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ s.jsx(fe, { iconName: "add", fontSize: "small" }),
          name: "save",
          children: "Add parameter"
        }
      ) }),
      children: [
        !a && j,
        a && U,
        D
      ]
    }
  );
}, La = gr((e) => {
  const { name: t, config: r, ...n } = e, {
    typeContainer: a,
    parentId: i,
    multiple: o,
    fastMarker: c,
    values: m,
    viewMode: p,
    buttonText: A,
    titleText: E,
    contextConceptSets: g,
    initialData: O,
    isSelect: S,
    returnEntityText: x,
    onChange: y,
    initialParams: f,
    classNameContainer: N,
    defaultState: I,
    availableSources: j,
    modalTitle: U,
    footer: D,
    embedded: W
  } = r;
  return /* @__PURE__ */ s.jsxs(et.Fragment, { children: [
    t === "widget-feature-import-button" && /* @__PURE__ */ s.jsx(
      Ua,
      {
        ...n,
        typeContainer: a,
        multiple: o,
        parentId: i,
        onChange: y,
        buttonText: A,
        titleText: E,
        initialData: O,
        isSelect: S,
        returnEntityText: x,
        classNameContainer: N,
        defaultState: I,
        availableSources: j,
        modalTitle: U,
        footer: D
      }
    ),
    t === "widget-feature-params" && /* @__PURE__ */ s.jsx(
      Fa,
      {
        ...n,
        titleText: E,
        viewMode: p,
        onChange: y,
        initialParams: f,
        embedded: W
      }
    )
  ] });
}), fr = {
  rowId: "id",
  loadingMessage: "Loading custom features...",
  addButtonTitle: "Add Custom Feature",
  tableTitle: "Custom Features",
  moduleDescription: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("strong", { children: "Feature Extraction" }),
    " is the process of generating descriptive statistics (covariates) for a specific population.",
    " ",
    /* @__PURE__ */ s.jsx("strong", { children: "Custom Features" }),
    " allow you to look beyond standard clinical characteristics to answer highly specific research questions about a cohort. You can define custom features using",
    " ",
    /* @__PURE__ */ s.jsx("strong", { children: "Criteria-based Features" }),
    " (Prevalence or Distribution type) or ",
    /* @__PURE__ */ s.jsx("strong", { children: "SQL-based Features" }),
    " (custom, parameterized SQL). Custom Features are used in ",
    /* @__PURE__ */ s.jsx("strong", { children: "Cohort Characterization" }),
    " analytics."
  ] }),
  importButtonTitle: "Import",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createCrudMethod: (e, t) => Fr(
    e,
    t,
    Qe,
    un,
    En,
    Cn,
    Qe
  ),
  cols: [
    Sr({
      Header: "",
      accessorFn: () => Ee.ANALYSIS,
      id: "typeEntityIcon",
      width: "2%",
      cell: Ce
    }),
    jt(),
    ot({
      width: "26%",
      cell: (e) => {
        var t, r, n, a;
        return /* @__PURE__ */ s.jsx(
          Nt,
          {
            text: (r = (t = e.row) == null ? void 0 : t.original) == null ? void 0 : r.description,
            color: "primary",
            width: "auto",
            children: /* @__PURE__ */ s.jsx(
              "div",
              {
                style: {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                },
                children: /* @__PURE__ */ s.jsx(Ft, { value: (a = (n = e.row) == null ? void 0 : n.original) == null ? void 0 : a.name })
              }
            )
          }
        );
      }
    }),
    {
      // Predefined domain values, so pin the width to fit the longest
      // ("Demographics") — PRO-3961 #4.2.
      header: "Domain",
      accessorFn: (e) => me(e).domain || "-",
      id: "domain",
      size: 140,
      minSize: 140,
      maxSize: 140,
      enableResizing: !1
    },
    {
      // Shrunk to fit the longest value ("Distribution") — PRO-3961 #4.3.
      header: "Type",
      accessorFn: (e) => Wt(e),
      id: "type",
      size: 110,
      minSize: 110,
      maxSize: 110,
      enableResizing: !1
    },
    {
      header: "Stat Type",
      accessorFn: (e) => qt(e),
      id: "statType",
      size: 110,
      minSize: 110,
      maxSize: 110,
      enableResizing: !1
    },
    Dt(),
    Ut(),
    wt()
  ],
  createSortingMethod(e) {
    return Bt(e, {
      getSorting: on,
      getSortingWorkspace: xn
    });
  },
  createFiltersPanel: (e, t) => tt(
    e,
    t,
    bt,
    Tn,
    hn,
    bt
  )
}, Pa = gr(
  ({ onCancel: e, onSubmit: t }) => {
    const [r, n] = X({
      name: "",
      description: "",
      domain: "",
      analysisType: L.PREVALENCE
    }), [a, i] = X(!1), o = async () => {
      i(!0);
      try {
        await t({
          name: r.name.trim(),
          description: r.description,
          domain: r.domain,
          analysisType: r.analysisType
        });
      } finally {
        i(!1);
      }
    };
    return /* @__PURE__ */ s.jsx(C, { container: !0, p: 2, children: /* @__PURE__ */ s.jsx(st, { elevated: !0, outlined: !0, children: /* @__PURE__ */ s.jsxs(C, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(Ne, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ s.jsx(
        we,
        {
          id: "name",
          name: "name",
          type: "text",
          size: "medium",
          value: r.name,
          placeholder: "Enter name",
          onChange: (c) => n((m) => ({
            ...m,
            name: c.target.value
          })),
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(Ne, { name: "description", textLabel: "Description", children: /* @__PURE__ */ s.jsx(
        we,
        {
          id: "description",
          name: "description",
          type: "text",
          size: "medium",
          value: r.description,
          placeholder: "Enter description",
          onChange: (c) => n((m) => ({
            ...m,
            description: c.target.value
          })),
          fullWidth: !0,
          multiline: !0,
          minRows: 2,
          maxRows: 10
        }
      ) }) }),
      /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, md: 6, children: /* @__PURE__ */ s.jsx(Ne, { name: "domain", textLabel: "Domain", required: !0, children: /* @__PURE__ */ s.jsx(
        We,
        {
          id: "domain",
          name: "domain",
          options: kr,
          value: r.domain,
          onChange: (c) => n((m) => ({
            ...m,
            domain: c
          })),
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, md: 6, children: /* @__PURE__ */ s.jsx(
        Ne,
        {
          name: "analysisType",
          textLabel: "Analysis type",
          required: !0,
          children: /* @__PURE__ */ s.jsx(
            We,
            {
              id: "analysisType",
              name: "analysisType",
              options: Vr,
              value: r.analysisType,
              onChange: (c) => n((m) => ({
                ...m,
                analysisType: c
              })),
              fullWidth: !0
            }
          )
        }
      ) }),
      /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsxs(vr, { children: [
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            variant: "outlined",
            onClick: e,
            startIcon: /* @__PURE__ */ s.jsx(fe, { iconName: "deactivate" }),
            name: "cancel",
            disabled: a,
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ae,
          {
            disabled: !r.name.trim() || !r.domain || a,
            onClick: o,
            variant: "contained",
            color: "success",
            startIcon: /* @__PURE__ */ s.jsx(fe, { iconName: "submit" }),
            name: "save",
            children: "Continue"
          }
        )
      ] }) })
    ] }) }) });
  }
), Ma = ({
  onImportFromLibrary: e,
  onImportFromJson: t
}) => {
  const [r, n] = X(
    Z.LIBRARY
  ), a = ne(
    () => [
      {
        value: Z.LIBRARY,
        title: "Artifacts library",
        onTabClick: () => n(Z.LIBRARY)
      },
      {
        value: or.MANUAL,
        title: "Manual",
        onTabClick: () => n(or.MANUAL)
      }
    ],
    []
  );
  return /* @__PURE__ */ s.jsxs(C, { container: !0, children: [
    /* @__PURE__ */ s.jsx(br, { elevation: 3, sx: { zIndex: 2, px: 2, width: "100%" }, children: /* @__PURE__ */ s.jsx(lt, { tabs: a, active: r }) }),
    /* @__PURE__ */ s.jsx(C, { container: !0, p: 2, children: /* @__PURE__ */ s.jsx(st, { elevated: !0, outlined: !0, children: /* @__PURE__ */ s.jsx(C, { item: !0, container: !0, xs: 12, p: 2, children: /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: r === Z.LIBRARY ? /* @__PURE__ */ s.jsx(
      Rn,
      {
        onChange: e,
        typeContainer: Z.LIBRARY,
        parentId: null,
        source: K.ARTIFACTS_LIBRARY,
        customOnly: !0
      }
    ) : /* @__PURE__ */ s.jsx(
      Qn,
      {
        codeKey: "expression",
        nameKey: "name",
        editorTitle: "Custom Feature JSON",
        fileExtension: wr.JSON,
        submitButtonText: "Import",
        onSubmit: t
      }
    ) }) }) }) })
  ] });
}, Ba = () => {
  var g;
  const e = Xe(), { enqueueSnackbar: t } = at(), { openModal: r, closeModal: n } = Te(vt), [a, i] = X(), o = Te(
    Pe
  ), c = ne(
    () => ({
      ...fr,
      createCrudMethod: (O, S) => {
        const x = fr.createCrudMethod(
          O,
          S
        );
        return {
          ...x,
          fetch: async (...y) => {
            var j, U, D;
            const f = await x.fetch(...y);
            (D = (j = o.config) == null ? void 0 : j.onCustomFeaturesCountChange) == null || D.call(
              j,
              Number(
                (f == null ? void 0 : f.totalElements) ?? (f == null ? void 0 : f.numberOfElements) ?? ((U = f == null ? void 0 : f.content) == null ? void 0 : U.length) ?? 0
              )
            );
            const N = Vt(f == null ? void 0 : f.actions), I = "create" in N ? N.create : !0;
            return {
              ...f,
              actions: {
                ...N,
                create: I,
                import: "import" in N ? N.import : I
              }
            };
          }
        };
      }
    }),
    [(g = o.config) == null ? void 0 : g.onCustomFeaturesCountChange]
  ), m = async (O) => {
    var S, x, y;
    try {
      const f = Ye(), N = Ot(
        {
          ...f,
          name: O.name,
          description: O.description,
          domain: O.domain
        },
        O.analysisType
      ), I = await De(
        de(N)
      );
      if (!(I != null && I.id))
        throw new Error("Unable to resolve created custom feature id");
      i(Ge()), window.dispatchEvent(new Event("prometheus:close-modal")), e(`/${o.path}/${I.id}`, {
        replace: !0
      });
    } catch (f) {
      t({
        message: ((x = (S = f == null ? void 0 : f.response) == null ? void 0 : S.data) == null ? void 0 : x.message) || ((y = f == null ? void 0 : f.response) == null ? void 0 : y.statusText) || (f == null ? void 0 : f.message) || "Unable to create custom feature.",
        variant: "error"
      });
    }
  }, p = (O) => {
    if (!(O != null && O.length)) return;
    const S = O[0], x = S == null ? void 0 : S.id;
    x && (window.dispatchEvent(new Event("prometheus:close-modal")), ut(String(x)).then(async (y) => {
      const f = me(y), N = {
        ...de(f),
        id: void 0,
        name: f.name || "Imported custom feature"
      }, I = await De(N);
      if (!(I != null && I.id))
        throw new Error("Unable to resolve created feature id");
      i(Ge()), e(`/${o.path}/${I.id}`, { replace: !1 });
    }).catch((y) => {
      var f, N;
      t({
        message: ((N = (f = y == null ? void 0 : y.response) == null ? void 0 : f.data) == null ? void 0 : N.message) || (y == null ? void 0 : y.message) || "Failed to import custom feature from Artifact Library.",
        variant: "error"
      });
    }));
  }, A = async (O) => {
    var f, N;
    const S = O.expression, x = (O.name || "").trim();
    if (!S) return;
    let y;
    try {
      y = JSON.parse(S);
    } catch {
      t({
        message: "Invalid JSON format.",
        variant: "error"
      });
      return;
    }
    try {
      const I = me(y), j = {
        ...de(I),
        id: void 0,
        name: x || I.name || "Imported custom feature"
      }, U = await De(j);
      if (!(U != null && U.id)) throw new Error("Unable to resolve created feature id");
      i(Ge()), window.dispatchEvent(new Event("prometheus:close-modal")), e(`/${o.path}/${U.id}`, { replace: !1 });
    } catch (I) {
      t({
        message: ((N = (f = I == null ? void 0 : I.response) == null ? void 0 : f.data) == null ? void 0 : N.message) || (I == null ? void 0 : I.message) || "Failed to import custom feature.",
        variant: "error"
      });
    }
  }, E = () => {
    r(
      () => /* @__PURE__ */ s.jsx(
        Ma,
        {
          onImportFromLibrary: p,
          onImportFromJson: A
        }
      ),
      "Import Custom Feature",
      {
        closeOnClickOutside: !0,
        width: "900px",
        onClose: n
      }
    );
  };
  return /* @__PURE__ */ s.jsx(
    Lt,
    {
      isImport: !0,
      onImport: E,
      moduleConfig: o,
      listConfig: c,
      reloadId: a,
      allowDelete: !1,
      pinnedColumns: {
        left: ["typeEntityIcon", "shortcut", "name"],
        right: ["actions"]
      },
      variant: "description",
      deleteSuccessMessage: (O) => `Feature analysis ${(O == null ? void 0 : O.name) || ""} is deleted`,
      onCreate: () => r(
        () => /* @__PURE__ */ s.jsx(
          Pa,
          {
            onCancel: n,
            onSubmit: m
          }
        ),
        "Add custom feature",
        {
          closeOnClickOutside: !0,
          width: "700px",
          onClose: n
        }
      )
    }
  );
}, Va = "New custom feature", Cr = {
  createCrudEntity: (e, t) => Pr(
    e,
    t,
    Je,
    un,
    ln,
    Ea,
    Ca
  ),
  entityBreadcrumbs: (e, t, r, n) => Lr(Va, e, t, r)
}, ze = (e) => String(e || "").trim().toUpperCase().replace(/[\s-]+/g, "_"), ka = ({ row: e }) => {
  var n, a, i, o;
  const t = ze((n = e == null ? void 0 : e.original) == null ? void 0 : n.supertype), r = ze((a = e == null ? void 0 : e.original) == null ? void 0 : a.type);
  return t === "COHORT" ? /* @__PURE__ */ s.jsx(Ce, { value: Ee.COHORT }) : t === "CONCEPT_SET" ? /* @__PURE__ */ s.jsx(Ce, { value: Ee.CONCEPT_SET }) : t === "ANALYSIS" ? (i = ht) != null && i[r] ? /* @__PURE__ */ s.jsx(ar, { value: r }) : /* @__PURE__ */ s.jsx(Ce, { value: Ee.ANALYSIS }) : (o = ht) != null && o[r] ? /* @__PURE__ */ s.jsx(ar, { value: r }) : r === "COHORT" ? /* @__PURE__ */ s.jsx(Ce, { value: Ee.COHORT }) : r === "CONCEPT_SET" ? /* @__PURE__ */ s.jsx(Ce, { value: Ee.CONCEPT_SET }) : /* @__PURE__ */ s.jsx(Ce, { value: Ee.ANALYSIS });
}, $a = [
  {
    header: "",
    accessorFn: (e) => e.type || e.supertype,
    id: "type",
    cell: ka,
    size: 40,
    enableResizing: !1,
    meta: {
      columnType: "action"
    }
  },
  ot()
], Ga = (e, t, r, n, a, i, o) => {
  const c = ze(i), m = c === "STUDY" ? Z.STUDY : c === "WORKSPACE" ? Z.WORKSPACE : n, p = c === "STUDY" && o ? o : a, A = ["workspace", "study-manager"], E = ["cohorts", "concept-sets", "analyses"], g = (I) => {
    const j = String(I || "").trim(), D = j.split(/[?#]/)[0].replace(/^\/+|\/+$/g, "").split("/").filter(Boolean), W = D.map((w) => w.toLowerCase()), d = W.findIndex(
      (w) => E.includes(w)
    );
    if (d >= 0) {
      const w = W[d], M = D[d + 1] || "";
      return {
        entity: w,
        entityId: M
      };
    }
    return {
      entity: void 0,
      entityId: (A.includes(W[0]) && D[1] ? D[1] : D[0]) || j
    };
  }, { entity: O, entityId: S } = g(e), x = ze(t), y = ze(r), f = m === Z.WORKSPACE || m === Z.LIBRARY ? "/workspace" : `/study-manager/${p}`, N = (() => {
    var I;
    return O || (y.includes("COHORT") ? "cohorts" : y.includes("CONCEPT_SET") ? "concept-sets" : y.includes("ANALYSIS") ? "analyses" : x.includes("COHORT") ? "cohorts" : x.includes("CONCEPT_SET") ? "concept-sets" : (x === "ANALYSIS" || x.endsWith("_ANALYSIS") || (I = ht) != null && I[x] && x !== "COHORT", "analyses"));
  })();
  return `${f}/${N}/${S}`;
}, On = ({
  id: e,
  typeContainer: t,
  parentId: r
}) => {
  const n = Xe(), a = Te(
    Pe
  );
  return /* @__PURE__ */ s.jsx(
    Lt,
    {
      isImport: !1,
      isEnableMetadata: !0,
      moduleConfig: a,
      uniqName: "FeatureAnalysisUsage",
      onRowClick: (i) => {
        const o = Ga(
          i.original.id,
          i.original.type,
          i.original.supertype,
          t,
          r,
          i.original.containerType,
          i.original.containerId
        );
        n(o);
      },
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading Used In references...",
        tableTitle: "Used In",
        moduleDescription: "",
        listInitialSort: { id: "name", desc: !1 },
        addButtonTitle: null,
        noDataMessage: "Not used in any analysis",
        createCrudMethod: () => ({
          fetch: (i, o, c, m) => Jt(e, {
            pageNumber: i,
            pageSize: o,
            sortBy: c,
            query: m
          })
        }),
        createFiltersPanel: () => ({
          getFilters: (i) => pa(i, e),
          formatFilters: is
        }),
        createSortingMethod: () => () => ya(e),
        cols: $a
      },
      variant: "no-header",
      pinnedColumns: { left: ["type", "name"], right: [] },
      dense: !0
    }
  );
}, Ya = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, za = (e) => {
  var n, a, i;
  const t = (e == null ? void 0 : e.shortcut) ?? ((n = e == null ? void 0 : e.raw) == null ? void 0 : n.shortcut) ?? (e == null ? void 0 : e.displayId) ?? ((a = e == null ? void 0 : e.raw) == null ? void 0 : a.displayId) ?? (e == null ? void 0 : e.externalId) ?? ((i = e == null ? void 0 : e.raw) == null ? void 0 : i.externalId) ?? (e == null ? void 0 : e.id);
  if (!t || t === "new")
    return null;
  const r = String(t);
  return Ya.test(r) ? null : r;
}, Wa = ({
  feature: e,
  viewMode: t,
  libraryMode: r,
  canDelete: n,
  canPublish: a,
  canExport: i,
  canCopy: o,
  canExportJson: c,
  additionalActions: m,
  disableSave: p,
  disablePublish: A,
  versionPreview: E,
  onVersionRevert: g,
  onNameChange: O,
  onDescriptionChange: S,
  onSave: x,
  onDelete: y,
  onPublish: f,
  onExport: N,
  onCopy: I,
  onExportJson: j
}) => {
  var d;
  const U = ds(), D = (e == null ? void 0 : e.subtype) === k.CRITERIA_SET ? "Criteria Set" : (e == null ? void 0 : e.subtype) === k.CUSTOM_SQL ? "Custom SQL" : "Preset", W = za(e);
  return /* @__PURE__ */ s.jsxs(C, { container: !0, pb: 1, pt: 2, spacing: 1, children: [
    /* @__PURE__ */ s.jsxs(C, { item: !0, xs: 12, container: !0, alignItems: "center", children: [
      /* @__PURE__ */ s.jsx(C, { item: !0, mr: 1.5, display: "flex", children: /* @__PURE__ */ s.jsx(Ce, { value: Ee.ANALYSIS, size: 32 }) }),
      /* @__PURE__ */ s.jsx(C, { item: !0, flexGrow: 1, minWidth: 0, mr: 1, children: /* @__PURE__ */ s.jsx(
        ir,
        {
          size: "medium",
          value: e == null ? void 0 : e.name,
          fullWidth: !0,
          color: U.palette.textColor.primary,
          onSubmit: (_) => O(_ || ""),
          onValueChange: (_) => O(_ || ""),
          disabled: t && !r || E,
          name: "custom-feature-name",
          required: !0,
          showActions: !1
        }
      ) }),
      !(t && !r) && !E && /* @__PURE__ */ s.jsx(C, { item: !0, ml: 1, children: /* @__PURE__ */ s.jsx(
        be,
        {
          color: "success",
          iconName: "save",
          disabled: p,
          tooltipText: "Save",
          title: "Save",
          name: "custom-feature-save",
          onClick: x
        }
      ) }),
      a && f && !E && /* @__PURE__ */ s.jsx(C, { item: !0, ml: 1, children: /* @__PURE__ */ s.jsx(
        Ae,
        {
          variant: "outlined",
          color: "primary",
          onClick: f,
          disabled: A,
          startIcon: /* @__PURE__ */ s.jsx(fe, { iconName: "publish" }),
          name: "custom-feature-publish",
          children: "Publish"
        }
      ) }),
      m && /* @__PURE__ */ s.jsx(C, { item: !0, ml: 1, className: "cohort-base-info__actions-additional", children: m }),
      o && I && !E && /* @__PURE__ */ s.jsx(C, { item: !0, ml: 1, children: /* @__PURE__ */ s.jsx(
        be,
        {
          color: "primary",
          iconName: "copy",
          onClick: I,
          tooltipText: "Copy",
          title: "Copy",
          name: "custom-feature-copy"
        }
      ) }),
      c && j && !E && /* @__PURE__ */ s.jsx(C, { item: !0, ml: 1, children: /* @__PURE__ */ s.jsx(
        be,
        {
          color: "primary",
          iconName: "export",
          onClick: j,
          tooltipText: "Export as JSON",
          title: "Export as JSON",
          name: "custom-feature-export-json"
        }
      ) }),
      !t && E ? /* @__PURE__ */ s.jsx(C, { item: !0, ml: 1, children: /* @__PURE__ */ s.jsx(
        be,
        {
          color: "primary",
          iconName: "reload",
          onClick: g,
          tooltipText: "Back to current version",
          title: "Back to current version",
          name: "custom-feature-version-revert"
        }
      ) }) : /* @__PURE__ */ s.jsx(s.Fragment, { children: !t && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        n && /* @__PURE__ */ s.jsx(C, { item: !0, ml: 1, children: /* @__PURE__ */ s.jsx(
          be,
          {
            color: "error",
            iconName: "delete",
            onClick: y,
            tooltipText: "Delete",
            title: "Delete",
            name: "custom-feature-delete",
            noExpand: !0
          }
        ) }),
        i && /* @__PURE__ */ s.jsx(C, { item: !0, ml: 1, children: /* @__PURE__ */ s.jsx(
          be,
          {
            color: "primary",
            iconName: "export",
            onClick: N,
            tooltipText: "Export",
            title: "Export",
            name: "custom-feature-export"
          }
        ) })
      ] }) })
    ] }),
    /* @__PURE__ */ s.jsxs(C, { item: !0, xs: 12, container: !0, columnSpacing: 2, children: [
      /* @__PURE__ */ s.jsxs(C, { item: !0, mr: 2, children: [
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Type:" }),
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", component: "span", fontWeight: 700, children: "Custom Feature" })
      ] }),
      W && /* @__PURE__ */ s.jsxs(C, { item: !0, mr: 2, children: [
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "ID:" }),
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", component: "span", fontWeight: 700, children: W })
      ] }),
      /* @__PURE__ */ s.jsxs(C, { item: !0, mr: 2, children: [
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Sub-type:" }),
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", component: "span", fontWeight: 700, children: D })
      ] }),
      (e == null ? void 0 : e.modified) && /* @__PURE__ */ s.jsxs(C, { item: !0, children: [
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Modified date:" }),
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", component: "span", fontWeight: 700, children: os(e.modified.timestamp) })
      ] }),
      ((d = e == null ? void 0 : e.created) == null ? void 0 : d.user) && /* @__PURE__ */ s.jsxs(C, { item: !0, children: [
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", component: "label", sx: { mr: 0.5 }, children: "Author:" }),
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", component: "span", fontWeight: 700, children: e.created.user.name })
      ] })
    ] }),
    !(t && !r && !(e != null && e.description)) && /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(
      ir,
      {
        value: e == null ? void 0 : e.description,
        onSubmit: (_) => S(_ || ""),
        onValueChange: (_) => S(_ || ""),
        color: U.palette.textColor.secondary,
        multiline: !0,
        fullWidth: !0,
        placeholder: t && !r ? "..." : "Add description...",
        disabled: t && !r || E,
        name: "custom-feature-description",
        showActions: !1,
        sx: {
          ml: -1,
          width: "calc(100% + 16px)"
        }
      }
    ) })
  ] });
}, bn = ({ feature: e, viewMode: t, onDomainChange: r, onAnalysisTypeChange: n }) => /* @__PURE__ */ s.jsxs(
  ie,
  {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 3,
    sx: {
      bgcolor: "common.white",
      boxSizing: "border-box",
      py: 1,
      width: "100%"
    },
    children: [
      /* @__PURE__ */ s.jsxs(ie, { display: "flex", alignItems: "center", gap: 1.25, children: [
        /* @__PURE__ */ s.jsxs(
          re,
          {
            component: "label",
            variant: "subtitle2",
            htmlFor: "custom-feature-domain",
            fontWeight: 700,
            whiteSpace: "nowrap",
            sx: { ".required": { color: "error.main" } },
            children: [
              "Domain",
              /* @__PURE__ */ s.jsx("span", { className: "required", children: "*" })
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(ie, { width: 180, children: /* @__PURE__ */ s.jsx(
          We,
          {
            id: "custom-feature-domain",
            name: "custom-feature-domain",
            options: kr,
            value: e.domain,
            onChange: r,
            disabled: t,
            fullWidth: !0
          }
        ) })
      ] }),
      /* @__PURE__ */ s.jsxs(ie, { display: "flex", alignItems: "center", gap: 1.25, children: [
        /* @__PURE__ */ s.jsxs(
          re,
          {
            component: "label",
            variant: "subtitle2",
            htmlFor: "custom-feature-analysis-type",
            fontWeight: 700,
            whiteSpace: "nowrap",
            sx: { ".required": { color: "error.main" } },
            children: [
              "Analysis type",
              /* @__PURE__ */ s.jsx("span", { className: "required", children: "*" })
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(ie, { width: 180, children: /* @__PURE__ */ s.jsx(
          We,
          {
            id: "custom-feature-analysis-type",
            name: "custom-feature-analysis-type",
            options: Vr,
            value: e.analysisType,
            onChange: n,
            disabled: t,
            fullWidth: !0
          }
        ) })
      ] })
    ]
  }
), _n = ({
  feature: e,
  subModules: t,
  typeContainer: r,
  parentId: n,
  viewMode: a,
  hideControls: i,
  onDomainChange: o,
  onAnalysisTypeChange: c,
  onCriteriaGroupsChange: m,
  onConceptSetsChange: p,
  onSqlChange: A
}) => {
  var I;
  const E = ne(
    () => kt[e.analysisType],
    [e.analysisType]
  ), g = E.supportsCriteria, O = E.supportsSql, S = E.supportsDistributeBy && g, x = e.analysisType === L.DISTRIBUTION, y = ((I = e.definition) == null ? void 0 : I.criteriaGroups) || [], f = g && !a && !y.length, N = ye(
    ({ section: j, sectionId: U, updateSection: D }) => {
      if (!S || !Gr(j))
        return null;
      const W = Yr(j), _ = W.map((w) => w.value).includes(j.distributeBy) ? j.distributeBy : oe.EVENTS_COUNT;
      return /* @__PURE__ */ s.jsx(C, { container: !0, py: 1, children: /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, md: 6, children: /* @__PURE__ */ s.jsx(
        Xn,
        {
          name: `distributionField-${U}`,
          htmlFor: `custom-feature-distribution-by-${U}`,
          textLabel: "Distribute by field value",
          required: !0,
          dense: !0,
          fullSize: !0,
          children: /* @__PURE__ */ s.jsx(
            We,
            {
              id: `custom-feature-distribution-by-${U}`,
              name: `custom-feature-distribution-by-${U}`,
              options: W,
              value: _,
              onChange: (w) => D(U, "distributeBy", w),
              disabled: a
            }
          )
        }
      ) }) });
    },
    [S, a]
  );
  return /* @__PURE__ */ s.jsxs(ie, { sx: { bgcolor: "common.white", width: "100%" }, children: [
    !i && /* @__PURE__ */ s.jsx(
      bn,
      {
        feature: e,
        viewMode: a,
        onDomainChange: o,
        onAnalysisTypeChange: c
      }
    ),
    g && /* @__PURE__ */ s.jsx(ie, { sx: { mt: 1, width: "100%" }, children: /* @__PURE__ */ s.jsx(
      t.cohort,
      {
        type: "component",
        name: "widget-criteria-group",
        subModules: t,
        config: {
          onChange: m,
          typeContainer: r,
          parentId: n,
          values: y,
          buttonText: "New criteria group",
          titleText: "",
          hiddenParentConcept: !0,
          hideIgnoreObservationPeriod: x,
          hiddenIgnoreObservationPeriodValue: x ? !0 : void 0,
          showRestrictToSameVisitForAllCriteria: x,
          useCohortSectionButtons: !0,
          hideCriteriaGroupHeader: !0,
          hideTopLevelCriteriaControls: e.analysisType === L.DISTRIBUTION,
          criteriaButtonsSx: {
            py: 0
          },
          criteriaSectionsSx: {
            bgcolor: "backgroundColor.dark",
            p: 1,
            mt: a ? 0 : 1,
            boxSizing: "border-box",
            rowGap: 1,
            minHeight: 32,
            alignItems: "center",
            ...f ? {
              "&::before": {
                content: '"Add Criteria Feature using Demographics, Health System, Clinical Events or Health Economics"',
                color: "text.secondary",
                display: "block",
                fontSize: 14,
                lineHeight: "20px",
                textAlign: "center",
                width: "100%"
              }
            } : {}
          },
          hideOccurrence: e.analysisType === L.DISTRIBUTION,
          renderSectionContentBeforeCriteria: N,
          contextConceptSets: {
            conceptSets: e.conceptSets || [],
            updateConceptSets: p,
            embeddedReferenceOnly: !0
          },
          viewMode: a
        }
      }
    ) }),
    !g && !O && /* @__PURE__ */ s.jsx(ie, { children: /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", color: "text.secondary", children: "Preset subtype does not require criteria definition." }) }),
    O && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsxs(ie, { sx: { mt: 1 }, children: [
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", sx: { mb: 1 }, children: "Analysis SQL:" }),
        /* @__PURE__ */ s.jsx(
          re,
          {
            component: "pre",
            variant: "body2",
            sx: {
              fontFamily: "monospace",
              mb: 0.5,
              overflowX: "auto",
              whiteSpace: "pre"
            },
            children: `SELECT covariate_id, covariate_name, concept_id, sum_value, average_value
FROM (`
          }
        ),
        /* @__PURE__ */ s.jsx(
          Nr,
          {
            data: e.definition.sql || "",
            language: "sql",
            placeholder: As,
            readOnly: a,
            enableValidation: !1,
            enableDownload: !1,
            editorOptions: {
              wordWrap: "on",
              wrappingIndent: "same",
              wrappingStrategy: "advanced",
              scrollbar: {
                horizontal: "hidden"
              }
            },
            placeholderStyles: {
              bottom: 0,
              overflow: "hidden",
              overflowWrap: "anywhere",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word"
            },
            onChange: (j) => A(j || ""),
            height: "520px"
          }
        ),
        /* @__PURE__ */ s.jsx(
          re,
          {
            component: "pre",
            variant: "body2",
            sx: {
              fontFamily: "monospace",
              mt: 0.5,
              whiteSpace: "pre"
            },
            children: ")"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs(ie, { sx: { mt: 2 }, children: [
        /* @__PURE__ */ s.jsx(re, { variant: "subtitle2", sx: { mb: 1 }, children: "Available variables:" }),
        /* @__PURE__ */ s.jsx(ie, { component: "ul", sx: { m: 0, pl: 3 }, children: gs.map((j) => /* @__PURE__ */ s.jsx(
          re,
          {
            component: "li",
            variant: "body2",
            color: "text.secondary",
            children: j
          },
          j
        )) })
      ] })
    ] })
  ] });
}, yt = (e) => {
  var t, r, n;
  return ((r = (t = e == null ? void 0 : e.response) == null ? void 0 : t.data) == null ? void 0 : r.message) || ((n = e == null ? void 0 : e.response) == null ? void 0 : n.statusText) || (e == null ? void 0 : e.message) || "Something went wrong";
}, qa = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, Kt = (e) => typeof e == "string" && qa.test(e), _t = (e) => {
  if (typeof e == "number" && Number.isFinite(e))
    return String(e);
  if (typeof e == "string") {
    const t = e.trim();
    return t || null;
  }
  return null;
}, ke = (e) => typeof e == "object" && e !== null, Ha = (e) => {
  var r;
  const t = (r = e == null ? void 0 : e.expression) == null ? void 0 : r.items;
  return Array.isArray(t) ? t.length : t && typeof t == "object" ? Object.keys(t).length : 0;
}, Qa = (e) => e ? Array.isArray(e) ? e.map((t) => ({
  concept: (t == null ? void 0 : t.concept) || {},
  includeDescendants: (t == null ? void 0 : t.includeDescendants) ?? (t == null ? void 0 : t.descendants) ?? !1,
  includeMapped: (t == null ? void 0 : t.includeMapped) ?? (t == null ? void 0 : t.mapped) ?? !1,
  isExcluded: (t == null ? void 0 : t.isExcluded) ?? (t == null ? void 0 : t.excluded) ?? !1,
  hierarchy: (t == null ? void 0 : t.hierarchy) ?? !1,
  id: t == null ? void 0 : t.id
})) : us(e) : [], Xa = (e, t) => t.reduce(
  (r, n) => ke(r) ? r[n] : void 0,
  e
), Ja = (e) => Array.isArray(e) ? e.length > 0 : e && typeof e == "object" ? Object.keys(e).length > 0 : !1, Ka = (e) => {
  const t = [
    ["items"],
    ["expression", "items"],
    ["conceptSet", "items"],
    ["conceptSet", "expression", "items"],
    ["conceptSetVersion", "items"],
    ["conceptSetVersion", "expression", "items"],
    ["version", "items"],
    ["version", "expression", "items"]
  ];
  for (const r of t) {
    const n = Xa(e, r);
    if (Ja(n))
      return n;
  }
}, Za = (e) => {
  const t = ke(e) && ke(e.data) ? e.data : ke(e) ? e : {}, r = ke(t.conceptSet) ? t.conceptSet : t;
  return {
    name: typeof t.name == "string" ? t.name : typeof r.name == "string" ? r.name : void 0,
    items: Ka(t),
    versionOrdinal: t.ordinal ?? t.versionOrdinal ?? t.version ?? r.ordinal ?? r.versionOrdinal ?? r.version
  };
}, ei = async (e) => {
  const t = e == null ? void 0 : e.conceptSets;
  if (!Array.isArray(t) || t.length === 0)
    return e;
  const r = await Promise.all(
    t.map(async (n) => {
      if (Ha(n) > 0 || !(n != null && n.versionId))
        return n;
      try {
        const a = await gn(
          String(n.versionId)
        ), i = Za(a);
        return {
          ...n,
          name: i.name ?? n.name,
          expression: {
            ...n.expression,
            items: Qa(i.items)
          },
          versionOrdinal: i.versionOrdinal ?? n.versionOrdinal,
          version: i.versionOrdinal ?? n.version
        };
      } catch {
        return n;
      }
    })
  );
  return {
    ...e,
    conceptSets: r
  };
}, Er = () => typeof globalThis < "u" && globalThis.crypto && typeof globalThis.crypto.randomUUID == "function" ? globalThis.crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
  const t = Math.floor(Math.random() * 16);
  return (e === "x" ? t : t & 3 | 8).toString(16);
}), ti = (e) => ({
  id: (e == null ? void 0 : e.id) ?? null,
  name: (e == null ? void 0 : e.name) || "New Concept set",
  uuid: (e == null ? void 0 : e.uuid) || (Kt(e == null ? void 0 : e.id) ? e.id : void 0),
  expression: (e == null ? void 0 : e.expression) || { items: [] },
  versionId: e == null ? void 0 : e.versionId,
  version: e == null ? void 0 : e.version,
  versionOrdinal: (e == null ? void 0 : e.versionOrdinal) ?? (e == null ? void 0 : e.version),
  currentVersionId: (e == null ? void 0 : e.currentVersionId) ?? (e == null ? void 0 : e.versionId),
  currentVersionOrdinal: (e == null ? void 0 : e.currentVersionOrdinal) ?? (e == null ? void 0 : e.versionOrdinal) ?? (e == null ? void 0 : e.version),
  needsDraftFeatureStoreFork: !0
}), ri = (e = [], t, r) => {
  if (!t)
    return e;
  const n = /* @__PURE__ */ new Set();
  return [r == null ? void 0 : r.id, r == null ? void 0 : r.uuid, r == null ? void 0 : r.externalId, t.id].forEach(
    (a) => {
      const i = _t(a);
      i && n.add(i);
    }
  ), n.size === 0 ? e : e.map((a) => [
    a == null ? void 0 : a.uuid,
    a == null ? void 0 : a.referenceId,
    a == null ? void 0 : a.externalId,
    a == null ? void 0 : a.id
  ].map(_t).filter(Boolean).some((c) => n.has(c)) ? {
    ...a,
    name: t.name ?? (a == null ? void 0 : a.name),
    uuid: (a == null ? void 0 : a.uuid) || (Kt(t.id) ? String(t.id) : void 0),
    versionId: t.versionId ?? (a == null ? void 0 : a.versionId),
    version: t.version ?? (a == null ? void 0 : a.version),
    versionOrdinal: t.versionOrdinal ?? t.version ?? (a == null ? void 0 : a.versionOrdinal),
    currentVersionId: t.currentVersionId ?? t.versionId ?? (a == null ? void 0 : a.currentVersionId),
    currentVersionOrdinal: t.currentVersionOrdinal ?? t.versionOrdinal ?? t.version ?? (a == null ? void 0 : a.currentVersionOrdinal)
  } : a);
}, ni = async (e) => {
  const t = [
    e == null ? void 0 : e.referenceId,
    e == null ? void 0 : e.uuid,
    e == null ? void 0 : e.externalId,
    e == null ? void 0 : e.id
  ].map(_t).find(Boolean);
  if (!t)
    throw new Error(
      `Unable to fork concept set "${(e == null ? void 0 : e.name) || "unknown"}"`
    );
  await ra(t, e == null ? void 0 : e.name);
}, si = async (e) => {
  const t = (e == null ? void 0 : e.conceptSets) || [];
  !Array.isArray(t) || t.length === 0 || await Promise.all(
    t.map((r) => r != null && r.isNewImport ? ni(r) : Promise.resolve())
  );
}, ai = (e, t) => {
  var a, i;
  const r = (t == null ? void 0 : t.conceptSets) || [], n = {
    ...e,
    definition: {
      ...e.definition,
      criteriaGroups: ((a = t == null ? void 0 : t.definition) == null ? void 0 : a.criteriaGroups) || ((i = e.definition) == null ? void 0 : i.criteriaGroups) || []
    }
  };
  return r.length === 0 ? n : {
    ...n,
    conceptSets: r
  };
}, ii = ({
  onCancel: e,
  onSave: t
}) => {
  const [r, n] = X({
    name: "",
    description: ""
  });
  return /* @__PURE__ */ s.jsx(C, { container: !0, p: 2, children: /* @__PURE__ */ s.jsx(st, { elevated: !0, outlined: !0, children: /* @__PURE__ */ s.jsxs(C, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(Ne, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ s.jsx(
      we,
      {
        id: "name",
        name: "name",
        type: "text",
        size: "medium",
        value: r.name,
        placeholder: "Enter name",
        onChange: (a) => n((i) => ({ ...i, name: a.target.value })),
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(Ne, { name: "description", textLabel: "Description", children: /* @__PURE__ */ s.jsx(
      we,
      {
        id: "description",
        name: "description",
        type: "text",
        size: "medium",
        value: r.description,
        placeholder: "Enter description",
        onChange: (a) => n((i) => ({ ...i, description: a.target.value })),
        fullWidth: !0,
        multiline: !0,
        minRows: 2,
        maxRows: 10
      }
    ) }) }),
    /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(re, { variant: "body2", color: "text.secondary", children: "This concept set will be added locally to the custom feature and saved with the draft feature." }) }),
    /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsxs(vr, { children: [
      /* @__PURE__ */ s.jsx(
        Ae,
        {
          variant: "outlined",
          onClick: e,
          startIcon: /* @__PURE__ */ s.jsx(fe, { iconName: "deactivate" }),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        Ae,
        {
          disabled: !r.name.trim(),
          onClick: () => {
            const a = Er(), i = Er();
            t({
              id: a,
              uuid: a,
              referenceId: a,
              versionId: i,
              currentVersionId: i,
              version: 1,
              versionOrdinal: 1,
              currentVersionOrdinal: 1,
              name: r.name.trim(),
              description: r.description,
              expression: { items: [] }
            });
          },
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ s.jsx(fe, { iconName: "submit" }),
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}, oi = ({
  subModules: e,
  typeContainer: t,
  parentId: r,
  conceptSetId: n,
  conceptSetModulePath: a,
  onClose: i,
  onConceptSetSaved: o,
  storage: c,
  initStorage: m
}) => /* @__PURE__ */ s.jsx("div", { style: { width: "100%", height: "100vh", backgroundColor: "#fff" }, children: /* @__PURE__ */ s.jsx(
  e.concept,
  {
    type: "component",
    name: "concept-set-entity-embedded",
    path: a,
    title: "Concept sets",
    subModules: e,
    storage: c,
    initStorage: m,
    rootSettings: {
      rootPath: a,
      rootTitle: "Concept sets"
    },
    config: {
      typeContainer: t,
      parentId: r,
      conceptSetId: n,
      onCancel: i,
      saveOnlyActions: !0,
      onConceptSetEntitySaved: o
    }
  }
) }), li = (e) => {
  var r, n, a;
  const t = [];
  return (r = e.name) != null && r.trim() || t.push("Name is required."), (n = e.domain) != null && n.trim() || t.push("Domain is required."), e.analysisType || t.push("Analysis type is required."), e.subtype || t.push("Subtype is required."), e.analysisType === L.CUSTOM && !((a = e.definition.sql) != null && a.trim()) && t.push("SQL query is required for Custom SQL subtype."), e.subtype === k.CRITERIA_SET && [
    L.DISTRIBUTION,
    L.PREVALENCE
  ].includes(e.analysisType) && (!Array.isArray(e.definition.criteriaGroups) || e.definition.criteriaGroups.length === 0) && t.push(
    "At least one criteria group is required for criteria-based features."
  ), t;
}, hr = (e, t) => {
  const r = Vt(e);
  return r && Object.keys(r).length > 0 ? r : t === "new" ? { create: !0, update: !0, delete: !1 } : {};
}, ui = (e) => {
  var t, r, n;
  return [401, 403].includes((t = e == null ? void 0 : e.response) == null ? void 0 : t.status) || /no authority/i.test(String(((n = (r = e == null ? void 0 : e.response) == null ? void 0 : r.data) == null ? void 0 : n.message) || ""));
}, ci = () => {
  var tr, rr, nr;
  const { id: e = "new" } = Rr(), [t] = Mn(), r = ls(t.get("typePublish")), n = Ir(), a = Xe(), i = Mr(), { enqueueSnackbar: o } = at(), c = cs((u) => u.user.data), m = Jn(), { showDialog: p, hideDialog: A } = Te(kn), { openModal: E, closeModal: g } = Te(vt), {
    rootSettings: O,
    path: S,
    title: x,
    config: y,
    subModules: f,
    storage: N,
    initStorage: I
  } = Te(
    Pe
  ), { rootPath: j, rootTitle: U } = O, { parentId: D, parentTitle: W, typeContainer: d } = y, _ = ne(
    () => Cr.createCrudEntity(d, D),
    [d, D]
  ), [w, M] = X(ae.INITIAL), [se, J] = X(null), [h, F] = X(
    Ye()
  ), [V, Y] = X(
    Ye()
  ), [te, $] = X({}), [l, R] = X(!1), [P, q] = X(0), [H, v] = X(!1), [Q, ue] = X(!0), [G] = X(
    () => {
      var u;
      return (u = n.state) == null ? void 0 : u.initialFeature;
    }
  ), ce = !!(y.publishRequestPreview || t.get("from") && t.get("from") === Z.LIBRARY), Ie = async () => {
    var u, T;
    try {
      const b = await ma({
        pageNumber: 0,
        pageSize: 1,
        sortBy: { id: "modified.timestamp", desc: !0 },
        query: ""
      }), B = (u = Vt(b == null ? void 0 : b.actions)) == null ? void 0 : u.create;
      return B == null ? !0 : !!B;
    } catch (b) {
      const B = (T = b == null ? void 0 : b.response) == null ? void 0 : T.status;
      if ([401, 403].includes(B))
        return !1;
      throw b;
    }
  };
  pe(() => {
    let u = !0;
    return (async () => {
      M(ae.IN_PROGRESS), J(null);
      try {
        if (e === "new") {
          if (!await Ie()) {
            if (!u)
              return;
            ue(!1), M(ae.ERROR), J({
              response: {
                status: 403,
                statusText: "Forbidden",
                message: "You do not have permission to create custom features.",
                data: null
              }
            });
            return;
          }
          const ct = Ye(), sr = {
            ...ct,
            name: (G == null ? void 0 : G.name) || ct.name,
            description: (G == null ? void 0 : G.description) || ct.description
          };
          u && ($({ create: !0, update: !0, delete: !1 }), F(sr), Y(sr), v(!1), M(ae.SUCCESS));
          return;
        }
        const b = await _.getMethod(e), B = await ei(
          me(b)
        );
        u && ($(hr(b == null ? void 0 : b.actions, e)), F(B), Y(B), v(!1), M(ae.SUCCESS));
      } catch (b) {
        u && (J(b), M(ae.ERROR));
      }
    })(), () => {
      u = !1;
    };
  }, [e, G, _.getMethod]), pe(() => {
    const u = (h == null ? void 0 : h.name) || "New custom feature";
    i(
      Br(
        Cr.entityBreadcrumbs(
          e,
          u,
          {
            path: (r == null ? void 0 : r.path) || S,
            title: (r == null ? void 0 : r.title) || x,
            rootPath: j,
            rootTitle: U,
            parentTitle: W,
            parentId: D
          },
          !1
        )
      )
    );
  }, [
    i,
    h == null ? void 0 : h.name,
    e,
    D,
    W,
    S,
    r == null ? void 0 : r.path,
    r == null ? void 0 : r.title,
    j,
    U,
    x
  ]), pe(() => {
    if (!e || e === "new") {
      q(0);
      return;
    }
    let u = !0;
    return Jt(e, {
      pageNumber: 0,
      pageSize: 1,
      sortBy: { id: "name", desc: !1 },
      query: ""
    }).then((T) => {
      if (!u)
        return;
      const b = Number(
        (T == null ? void 0 : T.totalElements) ?? (T == null ? void 0 : T.numberOfElements) ?? (Array.isArray(T == null ? void 0 : T.content) ? T.content.length : 0)
      );
      q(Number.isNaN(b) ? 0 : b);
    }).catch(() => {
      u && q(0);
    }), () => {
      u = !1;
    };
  }, [e]);
  const Re = ne(() => {
    var b, B;
    if (e === "new")
      return !0;
    if ("update" in te)
      return !!te.update;
    const u = (B = (b = h == null ? void 0 : h.created) == null ? void 0 : b.user) == null ? void 0 : B.id;
    return u != null && (c == null ? void 0 : c.id) != null && String(u) === String(c.id) || m;
  }, [
    te,
    c == null ? void 0 : c.id,
    (rr = (tr = h == null ? void 0 : h.created) == null ? void 0 : tr.user) == null ? void 0 : rr.id,
    e,
    m
  ]), Ke = ne(() => e === "new" ? !1 : ce || H ? !0 : !Re, [Re, e, ce, H]), Sn = !!(Re || te != null && te["update.name"] || te != null && te["update.description"]), Me = ne(
    () => Xs(h),
    [h]
  ), Zt = ye(() => d === Z.STUDY ? `study-manager/${D}/concept-sets` : "workspace/concept-sets", [D, d]), vn = ye(() => d === Z.LIBRARY ? new Promise((u) => {
    let T = !1;
    const b = (B) => {
      T || (T = !0, g(), u(B));
    };
    E(
      () => /* @__PURE__ */ s.jsx(
        ii,
        {
          onCancel: () => b(void 0),
          onSave: (B) => b(B)
        }
      ),
      "Create concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: () => b(void 0)
      }
    );
  }) : new Promise((u) => {
    let T = !1;
    const b = (B) => {
      T || (T = !0, g(), u(B));
    };
    E(
      () => /* @__PURE__ */ s.jsx(
        f.concept,
        {
          type: "component",
          name: "concept-set-form",
          subModules: f,
          config: {
            typeContainer: d,
            parentId: D,
            onCancel: () => b(void 0),
            onSave: (B) => b(ti(B))
          }
        }
      ),
      "Create concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: () => b(void 0)
      }
    );
  }), [g, E, D, f, d]);
  ye(
    (u) => {
      const T = [u == null ? void 0 : u.uuid, u == null ? void 0 : u.externalId, u == null ? void 0 : u.id].map(
        (B) => typeof B == "string" ? B.trim() : typeof B == "number" ? String(B) : ""
      ).find(Kt);
      if (!T) {
        o({
          message: "Concept set is not available for editing yet.",
          variant: "error"
        });
        return;
      }
      const b = Zt();
      E(
        () => /* @__PURE__ */ s.jsx(
          oi,
          {
            subModules: f,
            typeContainer: d,
            parentId: D,
            conceptSetId: String(T),
            conceptSetModulePath: b,
            storage: N,
            initStorage: I,
            onClose: g,
            onConceptSetSaved: (B) => {
              F((le) => ({
                ...le,
                conceptSets: ri(
                  le.conceptSets || [],
                  B,
                  {
                    id: u == null ? void 0 : u.id,
                    uuid: u == null ? void 0 : u.uuid,
                    externalId: u == null ? void 0 : u.externalId
                  }
                )
              }));
            }
          }
        ),
        "Concept sets",
        {
          closeOnClickOutside: !1,
          width: "95%",
          onClose: g
        }
      );
    },
    [
      g,
      o,
      Zt,
      I,
      E,
      D,
      N,
      f,
      d
    ]
  ), pe(() => {
    !Me && n.pathname.endsWith("/concept-sets") && a(`/${S}/${e}`, { replace: !0 });
  }, [e, n.pathname, a, S, Me]);
  const Nn = ne(() => {
    var b;
    const u = ((b = h == null ? void 0 : h.conceptSets) == null ? void 0 : b.length) || 0, T = [
      {
        title: "Definition",
        value: "",
        end: !0
      }
    ];
    return Me && T.push({
      title: /* @__PURE__ */ s.jsx(
        Ct,
        {
          title: "Concept Sets",
          count: u,
          status: ae.SUCCESS,
          dense: !0
        }
      ),
      value: "concept-sets",
      end: !1
    }), e !== "new" && T.push({
      id: "usage",
      align: "right",
      iconOnly: !0,
      iconName: "users",
      title: /* @__PURE__ */ s.jsx(
        Ct,
        {
          title: "Used In",
          count: P,
          status: ae.SUCCESS,
          dense: !0
        }
      ),
      value: "usage",
      end: !1
    }), T;
  }, [(nr = h == null ? void 0 : h.conceptSets) == null ? void 0 : nr.length, e, Me, P]), er = ne(
    () => !lr(
      de(V),
      de(h)
    ),
    [h, V]
  ), jn = async (u) => {
    const T = li(u);
    if (T.length > 0) {
      o({
        message: T[0],
        variant: "error"
      });
      return;
    }
    R(!0);
    try {
      await si(u);
      const b = e === "new" ? de(u) : Hs(V, u), B = await _.upsertMethod(b, e), le = ai(
        me(B),
        u
      );
      $(
        hr(B == null ? void 0 : B.actions, (le == null ? void 0 : le.id) || e)
      ), Y(le), F(le), v(!1), o({
        message: "Custom feature saved successfully.",
        variant: "success"
      }), e === "new" && (le != null && le.id) && a(`../${le.id}`, { replace: !0 });
    } catch (b) {
      ui(b) ? ($((B) => ({ ...B, update: !1, delete: !1 })), o({
        message: "You do not have permission to edit this custom feature. Only its author or a data steward can change it.",
        variant: "error"
      })) : o({
        message: yt(b),
        variant: "error"
      });
    } finally {
      R(!1);
    }
  }, Dn = () => {
    p(es, {
      onSubmit: async () => {
        try {
          await _.deleteMethod(h.id), A(), o({
            message: `Feature analysis ${(h == null ? void 0 : h.name) || ""} is deleted`,
            variant: "success"
          }), a(`/${S}`);
        } catch (u) {
          A(), o({
            message: yt(u),
            variant: "error"
          });
        }
      },
      onClose: A,
      text: `Are you sure you want to delete ${(h == null ? void 0 : h.name) || "this custom feature"}?`,
      confirmButtonText: "DELETE",
      variant: "error"
    });
  }, Un = () => {
    E(
      () => /* @__PURE__ */ s.jsx(
        Zn,
        {
          propId: "featureAnalysisId",
          onClose: g,
          item: h,
          inviteMethod: ha
        }
      ),
      "Publish custom feature",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: g
      }
    );
  }, wn = () => {
    E(
      () => /* @__PURE__ */ s.jsx(
        Kn,
        {
          id: h.id,
          name: h.name,
          parentId: D,
          currentContainer: d,
          createCopyMethod: xa,
          typeEntity: "feature-analyses",
          onChange: g
        }
      ),
      "Export custom feature",
      {
        closeOnClickOutside: !0,
        onClose: g
      }
    );
  }, Fn = async () => {
    var u, T;
    try {
      const B = {
        ...de(h),
        id: void 0,
        name: `Copy of ${h.name || "custom feature"}`
      }, le = await De(B);
      o({
        message: "Custom feature copied successfully.",
        variant: "success"
      }), a(`/${S}/${le.id}`, { replace: !1 });
    } catch (b) {
      o({
        message: ((T = (u = b == null ? void 0 : b.response) == null ? void 0 : u.data) == null ? void 0 : T.message) || (b == null ? void 0 : b.message) || "Failed to copy custom feature.",
        variant: "error"
      });
    }
  }, Ln = () => {
    const u = de(h), T = JSON.stringify(u, null, 2);
    E(
      () => /* @__PURE__ */ s.jsx(
        Nr,
        {
          data: T,
          fileName: h.name || "custom-feature",
          language: "json",
          readOnly: !0,
          fileExtension: wr.JSON
        }
      ),
      "Export custom feature as JSON",
      {
        closeOnClickOutside: !0,
        width: "800px",
        onClose: g
      }
    );
  };
  if (w === ae.ERROR) {
    if (!Q && e === "new")
      return /* @__PURE__ */ s.jsx(Fe, { children: /* @__PURE__ */ s.jsx(
        Et,
        {
          status: 403,
          statusText: "Forbidden",
          message: "You do not have permission to create custom features.",
          data: null,
          path: S
        }
      ) });
    const u = (se == null ? void 0 : se.response) || {
      status: 500,
      statusText: "Internal Server Error",
      message: yt(se),
      data: null
    };
    return /* @__PURE__ */ s.jsx(Fe, { children: /* @__PURE__ */ s.jsx(Et, { ...u, path: S }) });
  }
  return w === ae.INITIAL || w === ae.IN_PROGRESS ? /* @__PURE__ */ s.jsx(jr, { children: /* @__PURE__ */ s.jsx(Ue, { size: 62 }) }) : /* @__PURE__ */ s.jsxs(C, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: [
    /* @__PURE__ */ s.jsx(Dr, { children: /* @__PURE__ */ s.jsx(
      Wa,
      {
        feature: h,
        viewMode: Ke,
        libraryMode: Sn,
        canDelete: !!(e !== "new" && ("delete" in te ? te.delete : Re)),
        canPublish: e !== "new" && d === Z.LIBRARY && !ce,
        canExport: !!(e !== "new" && [Z.STUDY, Z.WORKSPACE].includes(
          d
        ) && Re),
        canCopy: e !== "new",
        onCopy: Fn,
        canExportJson: e !== "new",
        onExportJson: Ln,
        additionalActions: ce && /* @__PURE__ */ s.jsx(
          f.library,
          {
            type: "component",
            name: "answer-publish-widget",
            subModules: f,
            config: {
              ...y,
              type: t.get("typePublish"),
              typeEntity: rs.FEATURE_ANALYSIS,
              nameEntity: h == null ? void 0 : h.name,
              id: t.get("id"),
              isRedirect: !0,
              requestStatus: t.get("status")
            }
          }
        ),
        versionPreview: H,
        onVersionRevert: () => {
          F(V), v(!1);
        },
        disableSave: !er || l,
        disablePublish: er || l,
        onNameChange: (u) => F((T) => ({
          ...T,
          name: u
        })),
        onDescriptionChange: (u) => F((T) => ({
          ...T,
          description: u
        })),
        onSave: () => jn(h),
        onDelete: Dn,
        onPublish: Un,
        onExport: wn
      }
    ) }),
    /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(
      bn,
      {
        feature: h,
        viewMode: Ke,
        onDomainChange: (u) => F((T) => ({
          ...T,
          domain: u
        })),
        onAnalysisTypeChange: (u) => F(
          (T) => Ot(T, u)
        )
      }
    ) }),
    /* @__PURE__ */ s.jsxs(C, { item: !0, xs: 12, children: [
      /* @__PURE__ */ s.jsx(lt, { tabs: Nn, withRouting: !0, secondary: !0 }),
      /* @__PURE__ */ s.jsx(_r, {})
    ] }),
    /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, pt: 0, pb: 2, children: /* @__PURE__ */ s.jsxs(St, { children: [
      /* @__PURE__ */ s.jsx(
        _e,
        {
          index: !0,
          element: /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(
            _n,
            {
              feature: h,
              subModules: f,
              typeContainer: d,
              parentId: D,
              viewMode: Ke,
              hideControls: !0,
              onDomainChange: (u) => F((T) => ({
                ...T,
                domain: u
              })),
              onAnalysisTypeChange: (u) => F(
                (T) => Ot(T, u)
              ),
              onCriteriaGroupsChange: (u) => F((T) => ({
                ...T,
                definition: {
                  ...T.definition,
                  criteriaGroups: u
                }
              })),
              onConceptSetsChange: (u) => F((T) => ({
                ...T,
                conceptSets: u
              })),
              onSqlChange: (u) => F((T) => ({
                ...T,
                definition: {
                  ...T.definition,
                  sql: u
                }
              }))
            }
          ) })
        }
      ),
      e !== "new" && /* @__PURE__ */ s.jsx(
        _e,
        {
          path: "usage",
          element: /* @__PURE__ */ s.jsx(C, { container: !0, item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(Ur, { children: /* @__PURE__ */ s.jsx(it, { outlined: !0, children: /* @__PURE__ */ s.jsx(
            On,
            {
              id: e,
              typeContainer: d,
              parentId: D
            }
          ) }) }) })
        }
      ),
      Me && /* @__PURE__ */ s.jsx(
        _e,
        {
          path: "concept-sets/*",
          element: /* @__PURE__ */ s.jsx(
            f.concept,
            {
              type: "component",
              name: "concept-set-sections-widget-new",
              subModules: f,
              config: {
                ...y,
                onChange: (u) => {
                  F((T) => {
                    const b = {
                      ...T,
                      conceptSets: u
                    };
                    return lr(
                      de(T),
                      de(b)
                    ) ? T : b;
                  });
                },
                conceptSets: h.conceptSets || [],
                viewMode: Ke,
                exportConceptSet: !0,
                circleMode: !0,
                hideSectionContent: !0,
                hideAddConceptSetAction: d === Z.LIBRARY,
                hideCopySectionAction: !0,
                hideEditSectionAction: !0,
                onAddConceptSet: vn
              }
            }
          )
        }
      )
    ] }) })
  ] });
}, di = {
  rowId: "id",
  loadingMessage: "Loading feature analysis...",
  addButtonTitle: "Add feature analysis",
  tableTitle: "Feature analyses",
  importButtonTitle: "Import",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createCrudMethod: (e, t) => Fr(
    e,
    t,
    Ze,
    () => Promise.resolve(),
    () => Promise.resolve(""),
    Ze,
    Ze
  ),
  createSortingMethod(e) {
    return Bt(e, {
      getSorting: pn
    });
  },
  createFiltersPanel: (e, t) => tt(
    e,
    t,
    () => Promise.resolve(""),
    () => Promise.resolve(""),
    () => Promise.resolve(""),
    mn
  )
}, mi = () => {
  const e = Te(
    Pe
  );
  return /* @__PURE__ */ s.jsx(
    Lt,
    {
      isImport: !1,
      moduleConfig: e,
      listConfig: di,
      allowDelete: !0
    }
  );
}, pi = "New feature analysis", Tr = {
  createCrudEntity: (e, t) => Pr(
    e,
    t,
    ut,
    () => Promise.resolve(),
    () => Promise.resolve()
  ),
  entityBreadcrumbs: (e, t, r, n) => Lr(pi, e, t, r)
};
Ar({});
const yi = (e) => {
  var r;
  const t = (r = e == null ? void 0 : e.expression) == null ? void 0 : r.items;
  return Array.isArray(t) ? t.length : t && typeof t == "object" ? Object.keys(t).length : 0;
}, fi = (e) => e ? Array.isArray(e) ? e.map((t) => ({
  concept: (t == null ? void 0 : t.concept) || {},
  includeDescendants: (t == null ? void 0 : t.includeDescendants) ?? (t == null ? void 0 : t.descendants) ?? !1,
  includeMapped: (t == null ? void 0 : t.includeMapped) ?? (t == null ? void 0 : t.mapped) ?? !1,
  isExcluded: (t == null ? void 0 : t.isExcluded) ?? (t == null ? void 0 : t.excluded) ?? !1,
  hierarchy: (t == null ? void 0 : t.hierarchy) ?? !1,
  id: t == null ? void 0 : t.id
})) : typeof e == "object" ? Object.values(e).map((t) => ({
  concept: (t == null ? void 0 : t.concept) || {},
  includeDescendants: (t == null ? void 0 : t.includeDescendants) ?? (t == null ? void 0 : t.descendants) ?? !1,
  includeMapped: (t == null ? void 0 : t.includeMapped) ?? (t == null ? void 0 : t.mapped) ?? !1,
  isExcluded: (t == null ? void 0 : t.isExcluded) ?? (t == null ? void 0 : t.excluded) ?? !1,
  hierarchy: (t == null ? void 0 : t.hierarchy) ?? !1,
  id: t == null ? void 0 : t.id
})) : [] : [], $e = (e) => typeof e == "object" && e !== null, Ci = (e, t) => t.reduce(
  (r, n) => $e(r) ? r[n] : void 0,
  e
), Ei = (e) => Array.isArray(e) ? e.length > 0 : e && typeof e == "object" ? Object.keys(e).length > 0 : !1, hi = (e) => {
  const t = [
    ["items"],
    ["expression", "items"],
    ["conceptSet", "items"],
    ["conceptSet", "expression", "items"],
    ["conceptSetVersion", "items"],
    ["conceptSetVersion", "expression", "items"],
    ["version", "items"],
    ["version", "expression", "items"]
  ];
  for (const r of t) {
    const n = Ci(e, r);
    if (Ei(n))
      return n;
  }
}, Ti = (e) => {
  const t = $e(e) && $e(e.data) ? e.data : $e(e) ? e : {}, r = $e(t.conceptSet) ? t.conceptSet : t;
  return {
    name: typeof t.name == "string" ? t.name : typeof r.name == "string" ? r.name : void 0,
    items: hi(t),
    versionOrdinal: t.ordinal ?? t.versionOrdinal ?? t.version ?? r.ordinal ?? r.versionOrdinal ?? r.version
  };
}, xi = async (e) => {
  const t = e == null ? void 0 : e.conceptSets;
  if (!Array.isArray(t) || t.length === 0)
    return e;
  const r = await Promise.all(
    t.map(async (n) => {
      if (yi(n) > 0)
        return n;
      try {
        const a = (n == null ? void 0 : n.referenceId) || (n == null ? void 0 : n.uuid) || (n == null ? void 0 : n.id), i = n != null && n.versionId ? await gn(String(n.versionId)) : a ? await fa(String(a)) : null, o = Ti(i);
        return {
          ...n,
          name: o.name ?? n.name,
          expression: {
            ...n.expression,
            items: fi(o.items)
          },
          versionOrdinal: o.versionOrdinal ?? n.versionOrdinal,
          version: o.versionOrdinal ?? n.version
        };
      } catch {
        return n;
      }
    })
  );
  return {
    ...e,
    conceptSets: r
  };
}, gi = () => {
  const { id: e } = Rr(), t = Mr(), r = Xe(), { enqueueSnackbar: n } = at(), { rootSettings: a, path: i, title: o, config: c, subModules: m } = Te(
    Pe
  ), { rootPath: p, rootTitle: A } = a, { parentId: E, parentTitle: g, typeContainer: O } = c, S = O === Z.LIBRARY, x = ne(
    () => Tr.createCrudEntity(O, E),
    [E, O]
  ), { entity: y, isVersionMode: f, status: N, error: I, revertEntity: j } = $n(
    {
      get: x.getMethod,
      update: x.upsertMethod,
      delete: x.deleteMethod
    },
    e,
    "Features"
  ), U = ne(
    () => y ? me(y) : null,
    [y]
  ), [D, W] = X(null), [d, _] = X(0);
  pe(() => {
    let F = !0;
    return (async () => {
      if (!U) {
        W(null);
        return;
      }
      const Y = await xi(
        U
      );
      F && W(Y);
    })(), () => {
      F = !1;
    };
  }, [U]);
  const w = ye(async () => {
    var F, V;
    if (y)
      try {
        const Y = me(y), $ = { ...de(Y), id: void 0 }, l = await De($);
        n({
          message: "Custom feature copied to Custom Features store.",
          variant: "success"
        }), r(`/library/custom-features/${l.id}`);
      } catch (Y) {
        n({
          message: ((V = (F = Y == null ? void 0 : Y.response) == null ? void 0 : F.data) == null ? void 0 : V.message) || (Y == null ? void 0 : Y.message) || "Failed to copy to Custom Features store.",
          variant: "error"
        });
      }
  }, [y, n, r]), M = y == null ? void 0 : y.type, se = O === Z.LIBRARY && [xe.CRITERIA_SET, xe.CUSTOM_FE].includes(
    M
  ), J = () => {
  };
  pe(() => {
    y && t(
      Br(
        Tr.entityBreadcrumbs(
          e,
          y == null ? void 0 : y.name,
          {
            path: i,
            title: o,
            rootPath: p,
            rootTitle: A,
            parentTitle: g,
            parentId: E
          },
          S
        )
      )
    );
  }, [
    t,
    y,
    e,
    E,
    g,
    i,
    p,
    A,
    o,
    S
  ]), pe(() => {
    if (!e) {
      _(0);
      return;
    }
    let F = !0;
    return Jt(e, {
      pageNumber: 0,
      pageSize: 1,
      sortBy: { id: "name", desc: !1 },
      query: ""
    }).then((V) => {
      if (!F)
        return;
      const Y = Number(
        (V == null ? void 0 : V.totalElements) ?? (V == null ? void 0 : V.numberOfElements) ?? (Array.isArray(V == null ? void 0 : V.content) ? V.content.length : 0)
      );
      _(Number.isNaN(Y) ? 0 : Y);
    }).catch(() => {
      F && _(0);
    }), () => {
      F = !1;
    };
  }, [e]);
  const h = ne(
    () => [
      {
        title: "Definition",
        value: "",
        end: !0
      },
      {
        id: "usage",
        align: "right",
        iconOnly: !0,
        iconName: "users",
        title: /* @__PURE__ */ s.jsx(
          Ct,
          {
            title: "Used In",
            count: d,
            status: ae.SUCCESS,
            dense: !0
          }
        ),
        value: "usage",
        end: !1
      }
    ],
    [d]
  );
  return N === ae.ERROR ? /* @__PURE__ */ s.jsx(Fe, { children: /* @__PURE__ */ s.jsx(Et, { ...I.response, path: i }) }) : N === ae.INITIAL || N === ae.IN_PROGRESS ? /* @__PURE__ */ s.jsx(jr, { children: /* @__PURE__ */ s.jsx(Ue, { size: 62 }) }) : /* @__PURE__ */ s.jsxs(C, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: [
    /* @__PURE__ */ s.jsx(Dr, { children: /* @__PURE__ */ s.jsx(
      ts,
      {
        entity: y,
        onSubmit: () => {
        },
        onCopy: () => {
        },
        versionPreview: f,
        onVersionRevert: j,
        onVersionSave: () => {
        },
        viewMode: S,
        disableSave: !0,
        onDelete: () => {
        },
        onPublish: () => {
        },
        AdditionalActions: /* @__PURE__ */ s.jsx(C, { item: !0, ml: 1, children: /* @__PURE__ */ s.jsx(
          be,
          {
            color: "primary",
            iconName: "export",
            onClick: w,
            tooltipText: "Copy to Custom Features",
            title: "Copy to Custom Features",
            name: "feature-analysis-copy-to-draft"
          }
        ) })
      }
    ) }),
    /* @__PURE__ */ s.jsxs(C, { item: !0, xs: 12, children: [
      /* @__PURE__ */ s.jsx(lt, { tabs: h, withRouting: !0, secondary: !0 }),
      /* @__PURE__ */ s.jsx(_r, {})
    ] }),
    /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, pt: 0, pb: 2, children: /* @__PURE__ */ s.jsxs(St, { children: [
      /* @__PURE__ */ s.jsx(
        _e,
        {
          index: !0,
          element: se && D ? /* @__PURE__ */ s.jsx(C, { item: !0, xs: 12, py: 2, children: /* @__PURE__ */ s.jsx(
            _n,
            {
              feature: D,
              subModules: m,
              typeContainer: O,
              parentId: E,
              viewMode: !0,
              onDomainChange: J,
              onAnalysisTypeChange: J,
              onCriteriaGroupsChange: J,
              onConceptSetsChange: J,
              onSqlChange: J
            }
          ) }) : null
        }
      ),
      /* @__PURE__ */ s.jsx(
        _e,
        {
          path: "usage",
          element: /* @__PURE__ */ s.jsx(C, { container: !0, item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(Ur, { children: /* @__PURE__ */ s.jsx(it, { outlined: !0, children: /* @__PURE__ */ s.jsx(
            On,
            {
              id: e,
              typeContainer: O,
              parentId: E
            }
          ) }) }) })
        }
      )
    ] }) })
  ] });
}, Pe = Ar(null), Ai = (e) => {
  var g;
  const { path: t, title: r, name: n, storage: a, rootSettings: i, initStorage: o } = e, c = ((g = e.config) == null ? void 0 : g.featureEntitySource) === "draft", [m, p] = X(i), [A, E] = X(!0);
  return pe(() => {
    i || p({
      rootPath: t,
      rootTitle: r
    }), E(!1);
  }, []), A ? /* @__PURE__ */ s.jsx(Fe, { children: /* @__PURE__ */ s.jsx(Ue, { size: 32 }) }) : /* @__PURE__ */ s.jsx(Pe.Provider, { value: { ...e, rootSettings: m }, children: /* @__PURE__ */ s.jsxs(St, { children: [
    /* @__PURE__ */ s.jsx(
      _e,
      {
        index: !0,
        element: c ? /* @__PURE__ */ s.jsx(Ba, {}) : /* @__PURE__ */ s.jsx(mi, {})
      }
    ),
    /* @__PURE__ */ s.jsx(
      _e,
      {
        path: ":id/*",
        element: c ? /* @__PURE__ */ s.jsx(ci, {}) : /* @__PURE__ */ s.jsx(gi, {})
      }
    )
  ] }) });
}, wi = (e) => {
  const { type: t } = e;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !t && /* @__PURE__ */ s.jsx(Ai, { ...e }),
    t === "component" && /* @__PURE__ */ s.jsx(La, { ...e })
  ] });
};
export {
  K as CustomFeatureImportSource,
  wi as FeatureAnalyses
};
//# sourceMappingURL=feature-analyses.js.map
